"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4259],{

/***/ 93282:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _care_react_component_lib__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(387);
/* harmony import */ var _care_react_icons__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(30575);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(61730);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(80822);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(69417);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(23795);
/* harmony import */ var _lib_analyticsHelper__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(883);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(42660);







var AssistedBioIndicator = function() {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), showAssistedBioModal = ref[0], setAssistedBioModal = ref[1];
    var isDesktop = (0,_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function(theme) {
        return theme.breakpoints.up("md");
    });
    var handleAssistedBioClick = function() {
        setAssistedBioModal(true);
        (0,_lib_analyticsHelper__WEBPACK_IMPORTED_MODULE_2__/* .trackAmplitudeEvent */ .rG)("CTA Interacted", {
            screen_name: _constants__WEBPACK_IMPORTED_MODULE_3__/* .ScreenName.PROVIDER */ .CG.PROVIDER,
            cta_text: "Assisted bio",
            cta_intent: "Click on assisted bio badge"
        });
        (0,_lib_analyticsHelper__WEBPACK_IMPORTED_MODULE_2__/* .trackAmplitudeEvent */ .rG)(_lib_analyticsHelper__WEBPACK_IMPORTED_MODULE_2__/* .AmplitudeEvent.providerProfileViewed */ .Sj.providerProfileViewed, {
            screen_name: _constants__WEBPACK_IMPORTED_MODULE_3__/* .ScreenName.AI_BIO */ .CG.AI_BIO
        });
    };
    var closeAssistedBioModal = function() {
        setAssistedBioModal(false);
        (0,_lib_analyticsHelper__WEBPACK_IMPORTED_MODULE_2__/* .trackAmplitudeEvent */ .rG)("CTA Interacted", {
            screen_name: _constants__WEBPACK_IMPORTED_MODULE_3__/* .ScreenName.AI_BIO */ .CG.AI_BIO,
            cta_text: "OK",
            cta_intent: "Dismiss assisted bio modal"
        });
    };
    var handleLearnMoreClick = function() {
        (0,_lib_analyticsHelper__WEBPACK_IMPORTED_MODULE_2__/* .trackAmplitudeEvent */ .rG)("CTA Interacted", {
            screen_name: _constants__WEBPACK_IMPORTED_MODULE_3__/* .ScreenName.PROVIDER */ .CG.PROVIDER,
            cta_text: "Learn more",
            cta_intent: "Click to learn more about assisted bio"
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                display: "flex",
                alignItems: "center",
                mt: 1.5,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_care_react_icons__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {}),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                        variant: "text",
                        sx: {
                            height: "30px",
                            fontWeight: "400",
                            fontSize: "info1.fontSize"
                        },
                        onClick: handleAssistedBioClick,
                        size: "large",
                        children: "Assisted bio"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_care_react_component_lib__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                open: showAssistedBioModal,
                onClose: closeAssistedBioModal,
                title: "What is an assisted bio?",
                children: [
                    "This caregiver wrote their bio using our AI tool, which summarizes their background based on their answers to questions about their skills and experience.",
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                        color: "secondary",
                        variant: "contained",
                        sx: {
                            mt: 3,
                            mb: 2
                        },
                        onClick: closeAssistedBioModal,
                        children: "OK"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                        sx: {
                            fontWeight: "700"
                        },
                        variant: "body2",
                        href: "https://help.care.com/families/s/article/What-is-an-Assisted-bio?language=en_US",
                        onClick: handleLearnMoreClick,
                        target: isDesktop ? "_blank" : "_self",
                        children: "Learn more"
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (AssistedBioIndicator);


/***/ }),

/***/ 5823:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": function() { return /* binding */ GAMAds; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _care_htl_bid__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(80976);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(86886);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(80822);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(42660);
/* harmony import */ var _hooks_useResponsive__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19147);







var GAMAds = function(param) {
    var slotName = param.slotName, slotProps = param.slotProps;
    var ref = (0,_hooks_useResponsive__WEBPACK_IMPORTED_MODULE_3__/* .useResponsive */ .F)(), isSmallViewport = ref.isSmallViewport, isMediumViewport = ref.isMediumViewport;
    var dimensions = function() {
        if (isSmallViewport) {
            return {
                width: 320,
                height: 50
            };
        }
        if (isMediumViewport) {
            return {
                width: 468,
                height: 50
            };
        }
        if (slotName === _constants__WEBPACK_IMPORTED_MODULE_2__/* .HTL_SLOTS.SEO_DIRECTORY_RR_1 */ .YQ.SEO_DIRECTORY_RR_1) {
            return {
                width: 300,
                height: 250
            };
        }
        if (slotName === _constants__WEBPACK_IMPORTED_MODULE_2__/* .HTL_SLOTS.SEO_PROV_PROFILE_RR_1 */ .YQ.SEO_PROV_PROFILE_RR_1) {
            return {
                width: 300,
                height: 600
            };
        }
        return {
            width: 728,
            height: 90
        };
    }();
    var width = dimensions.width, height = dimensions.height;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP, {
        className: slotName,
        item: true,
        xs: 12,
        display: "flex",
        justifyContent: "center",
        pt: {
            xs: 1,
            sm: 5
        },
        pb: {
            xs: 4,
            sm: 8
        },
        sx: {
            "&.seo-prov-profile-inline-1, &.seo-prov-profile-inline-2": {
                pt: {
                    xs: 4,
                    md: 16
                },
                pb: 4
            },
            "&.seo-prov-profile-inline-2": {
                pt: {
                    xs: 4
                },
                pb: 4
            }
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
            width: "".concat(width, "px"),
            height: "".concat(height, "px")
        }, slotProps), {
            overflow: "visible",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_care_htl_bid__WEBPACK_IMPORTED_MODULE_1__/* .HTLBIDSlot */ .qF, {
                slotName: slotName
            })
        }))
    });
};



/***/ }),

/***/ 6150:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ SafetyModalWrapper; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(97582);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _care_caregiver_profile_components__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(55138);
/* harmony import */ var _generated_globalTypes__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(79967);
/* harmony import */ var _utils_getZipcodeFromGeoInfo__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(7360);
/* harmony import */ var _contexts_PageAttributesContext__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(73739);
/* harmony import */ var _hooks_useZipCodeValidation__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(89698);









var SafetyModalWrapper = function(param) {
    var openModal = param.openModal, setOpenModal = param.setOpenModal, _isCaregiverProfilePage = param.isCaregiverProfilePage, isCaregiverProfilePage = _isCaregiverProfilePage === void 0 ? false : _isCaregiverProfilePage, _caregiverStateCode = param.caregiverStateCode, caregiverStateCode = _caregiverStateCode === void 0 ? null : _caregiverStateCode;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), isFromMassachusetts = ref[0], setIsFromMassachusetts = ref[1];
    var ref1 = (0,_contexts_PageAttributesContext__WEBPACK_IMPORTED_MODULE_3__/* .usePageAttributes */ .l)(), userGeoInfo = ref1.userGeoInfo, seoSegmentId = ref1.seoSegmentId;
    var validate = (0,_hooks_useZipCodeValidation__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)().validate;
    var getStateCodeFromSegmentId = function(segmentId) {
        var segment = segmentId.split("/").pop();
        if (segment === null || segment === void 0 ? void 0 : segment.includes("-")) {
            var state = segment.split("-").pop();
            var ref;
            return (ref = state === null || state === void 0 ? void 0 : state.toUpperCase()) !== null && ref !== void 0 ? ref : null;
        }
        return null;
    };
    var stateCodeFromSegmentId = getStateCodeFromSegmentId(seoSegmentId);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var fetchStateLocation = function() {
            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
                var zipCode, data;
                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            zipCode = (0,_utils_getZipcodeFromGeoInfo__WEBPACK_IMPORTED_MODULE_7__/* .getZipcodeFromGeoInfo */ .Z)(userGeoInfo);
                            return [
                                4,
                                validate(zipCode)
                            ];
                        case 1:
                            data = _state.sent();
                            if ((data === null || data === void 0 ? void 0 : data.state) === _generated_globalTypes__WEBPACK_IMPORTED_MODULE_2__/* .UsStateCode.MA */ .y9.MA) {
                                setIsFromMassachusetts(true);
                            }
                            return [
                                2
                            ];
                    }
                });
            });
            return function fetchStateLocation() {
                return _ref.apply(this, arguments);
            };
        }();
        if (isCaregiverProfilePage) {
            setIsFromMassachusetts(caregiverStateCode === _generated_globalTypes__WEBPACK_IMPORTED_MODULE_2__/* .UsStateCode.MA */ .y9.MA);
        } else {
            setIsFromMassachusetts(stateCodeFromSegmentId === _generated_globalTypes__WEBPACK_IMPORTED_MODULE_2__/* .UsStateCode.MA */ .y9.MA);
        }
        fetchStateLocation();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_care_caregiver_profile_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
        open: openModal,
        onClose: function() {
            return setOpenModal(false);
        },
        newSafetyExperienceEnabled: true,
        isMAProviderOrSeeker: isFromMassachusetts
    });
};



/***/ }),

/***/ 32778:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "y": function() { return /* binding */ useLDClientFlags; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(828);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(42660);
/* harmony import */ var _components_contexts_FeatureFlagsContext__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(63880);



var useLDClientFlags = function() {
    var featureFlags = (0,_components_contexts_FeatureFlagsContext__WEBPACK_IMPORTED_MODULE_1__/* .useFeatureFlags */ .g)();
    var activeFlags = {};
    return Object.entries(_constants__WEBPACK_IMPORTED_MODULE_0__/* .UI_FEATURE_FLAGS */ .WV).reduce(function(acc, flag) {
        var ref;
        var _flag = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(flag, 2), flagName = _flag[0], flagDetails = _flag[1];
        var currentFlag = featureFlags === null || featureFlags === void 0 ? void 0 : (ref = featureFlags.flags) === null || ref === void 0 ? void 0 : ref[flagDetails.id];
        acc[flagName] = currentFlag;
        return acc;
    }, activeFlags);
};


/***/ }),

/***/ 19147:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ useResponsive; }
/* harmony export */ });
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61730);

function useResponsive() {
    var isSmallViewport = (0,_mui_material__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function(theme) {
        return theme.breakpoints.down("sm");
    }); // Mobile Devices
    var isMediumViewport = (0,_mui_material__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function(theme) {
        return theme.breakpoints.between("sm", "lg");
    }); // Large Mobile and Tablets
    var isLargeViewport = (0,_mui_material__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function(theme) {
        return theme.breakpoints.up("lg");
    }); // Small and Large Desktops
    return {
        isSmallViewport: isSmallViewport,
        isMediumViewport: isMediumViewport,
        isLargeViewport: isLargeViewport
    };
}



/***/ }),

/***/ 89698:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ useZipCodeValidation; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@apollo/client/react/hooks/useLazyQuery.js + 2 modules
var useLazyQuery = __webpack_require__(45910);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/graphql-tag/lib/index.js + 12 modules
var lib = __webpack_require__(68806);
;// CONCATENATED MODULE: ./src/API/seoSegmentationValidateZipCode.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query validateZipCode($input: SEOValidateZipCodeInput!) {\n    seoSegmentationValidateZipCode(input: $input) {\n      ... on SEOValidateZipCodeSuccess {\n        __typename\n        city\n        state\n      }\n      ... on SEOValidateZipCodeError {\n        __typename\n        error {\n          message\n          ... on DataNotAvailableError {\n            message\n          }\n          ... on DataNotAvailableForGivenPageNumberError {\n            message\n          }\n          ... on UrlNotFoundError {\n            message\n          }\n          ... on InvalidSEOZipCodeError {\n            message\n          }\n        }\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var VALIDATE_ZIP_CODE = (0,lib/* gql */.Ps)(_templateObject());
/* harmony default export */ var seoSegmentationValidateZipCode = (VALIDATE_ZIP_CODE);

;// CONCATENATED MODULE: ./src/components/hooks/useZipCodeValidation.tsx






function useZipCodeValidation() {
    var ref = (0,react.useState)(""), zipCode = ref[0], setZipCode = ref[1];
    var ref1 = (0,react.useState)(""), city = ref1[0], setCity = ref1[1];
    var ref2 = (0,react.useState)(""), state = ref2[0], setState = ref2[1];
    var ref3 = (0,react.useState)(false), hasError = ref3[0], setHasError = ref3[1];
    var ref4 = (0,_sliced_to_array/* default */.Z)((0,useLazyQuery/* useLazyQuery */.t)(seoSegmentationValidateZipCode, {
        variables: {
            input: {
                zipcode: zipCode
            }
        }
    }), 1), validateZipCode = ref4[0];
    var validate = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var newZipCode, ref, ref1, response, res;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        newZipCode = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : "";
                        setHasError(false);
                        setZipCode(newZipCode);
                        if (newZipCode.length < 5) {
                            setCity("");
                            setState("");
                            setHasError(false);
                            return [
                                2,
                                Promise.resolve({
                                    zipCode: zipCode,
                                    city: "",
                                    state: ""
                                })
                            ];
                        }
                        if (!(newZipCode.length === 5)) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            validateZipCode({
                                variables: {
                                    input: {
                                        zipcode: newZipCode
                                    }
                                }
                            })
                        ];
                    case 1:
                        response = _state.sent();
                        res = response === null || response === void 0 ? void 0 : (ref = response.data) === null || ref === void 0 ? void 0 : ref.seoSegmentationValidateZipCode;
                        if ((res === null || res === void 0 ? void 0 : res.__typename) === "SEOValidateZipCodeSuccess") {
                            setCity(res === null || res === void 0 ? void 0 : res.city);
                            setState(res === null || res === void 0 ? void 0 : res.state);
                            return [
                                2,
                                Promise.resolve({
                                    zipCode: newZipCode,
                                    city: res === null || res === void 0 ? void 0 : res.city,
                                    state: res === null || res === void 0 ? void 0 : res.state
                                })
                            ];
                        }
                        if (newZipCode.length === 5 && (res === null || res === void 0 ? void 0 : (ref1 = res.error) === null || ref1 === void 0 ? void 0 : ref1.__typename) === "InvalidSEOZipCodeError") {
                            setCity("");
                            setState("");
                            setHasError(true);
                            return [
                                2,
                                Promise.resolve({
                                    zipCode: newZipCode,
                                    city: "",
                                    state: ""
                                })
                            ];
                        }
                        _state.label = 2;
                    case 2:
                        return [
                            2,
                            Promise.resolve({
                                zipCode: zipCode,
                                city: city,
                                state: state
                            })
                        ];
                }
            });
        });
        return function validate() {
            return _ref.apply(this, arguments);
        };
    }();
    return {
        validate: validate,
        hasError: hasError
    };
}


/***/ }),

/***/ 94259:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ caregiver_UnifiedCaregiverDetail; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/config.js
var config = __webpack_require__(11752);
var config_default = /*#__PURE__*/__webpack_require__.n(config);
// EXTERNAL MODULE: ./node_modules/@care/navigation/dist/components/CoreGlobalFooter/CoreGlobalFooter.js + 8 modules
var CoreGlobalFooter = __webpack_require__(69388);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/useMediaQuery/useMediaQuery.js
var useMediaQuery = __webpack_require__(61730);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js + 1 modules
var Box = __webpack_require__(80822);
// EXTERNAL MODULE: ./node_modules/@mui/material/Container/Container.js + 1 modules
var Container = __webpack_require__(65582);
// EXTERNAL MODULE: ./node_modules/@mui/material/Grid/Grid.js + 2 modules
var Grid = __webpack_require__(86886);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(15861);
// EXTERNAL MODULE: ./node_modules/@mui/material/ClickAwayListener/ClickAwayListener.js
var ClickAwayListener = __webpack_require__(7982);
// EXTERNAL MODULE: ./node_modules/@mui/material/Tooltip/Tooltip.js + 1 modules
var Tooltip = __webpack_require__(34386);
// EXTERNAL MODULE: ./node_modules/@care/react-icons/dist/Icon24UtilityInfoFilled.js
var Icon24UtilityInfoFilled = __webpack_require__(99701);
// EXTERNAL MODULE: ./node_modules/@care/caregiver-profile-components/dist/components/ExpandableBlock/ExpandableBlock.js + 1 modules
var ExpandableBlock = __webpack_require__(78008);
// EXTERNAL MODULE: ./src/components/AssistedBioIndicator.tsx
var AssistedBioIndicator = __webpack_require__(93282);
;// CONCATENATED MODULE: ./src/components/CaregiverProfile/AboutCaregiver.tsx






var AboutCaregiver = function(param) {
    var experienceSummary = param.experienceSummary, isVaccinated = param.isVaccinated, yearsOfExperience = param.yearsOfExperience, isAiAssistedBio = param.isAiAssistedBio;
    var ref = (0,react.useState)(false), openCovidTooltip = ref[0], setOpenCovidTooltip = ref[1];
    var handleCovidTooltip = function(action) {
        if (action === "open" !== openCovidTooltip) {
            setOpenCovidTooltip(action === "open");
        }
    };
    var getCovidTooltipHtml = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
            variant: "body3",
            "aria-label": "covid-tooltip",
            "data-testid": "covid-tooltip-text",
            children: "This caregiver has indicated they are fully vaccinated against COVID-19. The information is self-reported and has not been verified by Care."
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
        item: true,
        xs: 12,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                item: true,
                container: true,
                xs: 12,
                spacing: 2,
                direction: "row",
                color: function(theme) {
                    return theme.palette.care.grey[600];
                },
                mb: 2,
                children: [
                    yearsOfExperience && yearsOfExperience >= 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                        item: true,
                        xs: "auto",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                            mr: 5,
                            alignSelf: "center",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                variant: "body3",
                                children: "Experience: ".concat(yearsOfExperience, " ").concat(yearsOfExperience === 1 ? "yr" : "yrs")
                            })
                        })
                    }),
                    isVaccinated && /*#__PURE__*/ (0,jsx_runtime.jsx)(ClickAwayListener/* ClickAwayListener */.d, {
                        onClickAway: function() {
                            return handleCovidTooltip("close");
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                            item: true,
                            "aria-label": "tooltip-focus-area",
                            onMouseLeave: function() {
                                return handleCovidTooltip("close");
                            },
                            // maxWidth fixes iOS Safari issue where on tooltip open the whole section would resize and jump
                            maxWidth: "180px",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.Z, {
                                PopperProps: {
                                    disablePortal: true
                                },
                                onClose: function() {
                                    return handleCovidTooltip("close");
                                },
                                open: openCovidTooltip,
                                disableFocusListener: true,
                                disableTouchListener: true,
                                disableHoverListener: true,
                                title: getCovidTooltipHtml(),
                                placement: "top",
                                arrow: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                                    container: true,
                                    alignItems: "center",
                                    "data-testid": "covid-tooltip",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                            variant: "info1",
                                            onClick: function() {
                                                return handleCovidTooltip("open");
                                            },
                                            children: "COVID-19 vaccinated"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon24UtilityInfoFilled/* default */.Z, {
                                            size: "24px",
                                            "aria-label": "covid-badge-icon",
                                            onMouseOver: function() {
                                                return handleCovidTooltip("open");
                                            },
                                            onFocus: function() {
                                                return handleCovidTooltip("open");
                                            },
                                            "data-testid": "covid-tooltip-icon"
                                        })
                                    ]
                                })
                            })
                        })
                    })
                ]
            }),
            experienceSummary && /*#__PURE__*/ (0,jsx_runtime.jsx)(ExpandableBlock/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    variant: "body2",
                    children: experienceSummary
                })
            }),
            isAiAssistedBio && /*#__PURE__*/ (0,jsx_runtime.jsx)(AssistedBioIndicator/* default */.Z, {})
        ]
    });
};


// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@care/react-component-lib/dist/components/Divider/Divider.js
var Divider = __webpack_require__(81956);
;// CONCATENATED MODULE: ./src/components/CaregiverProfile/Section.tsx





var Section = function(param) {
    var children = param.children, _displayDivider = param.displayDivider, displayDivider = _displayDivider === void 0 ? false : _displayDivider, title = param.title, additionalComponent = param.additionalComponent, _useH1Variant = param.useH1Variant, useH1Variant = _useH1Variant === void 0 ? false : _useH1Variant, _headerBottomMargin = param.headerBottomMargin, headerBottomMargin = _headerBottomMargin === void 0 ? 3 : _headerBottomMargin, slotProps = param.slotProps;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
        container: true,
        item: true,
        xs: 12,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
            component: "section",
            mt: 0,
            width: "100%",
            children: [
                displayDivider && /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, (0,_object_spread/* default */.Z)({}, slotProps === null || slotProps === void 0 ? void 0 : slotProps.divider)),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                    container: true,
                    item: true,
                    xs: 12,
                    justifyContent: "space-between",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                            mb: {
                                xs: headerBottomMargin
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                variant: useH1Variant ? "h1" : "h2",
                                fontSize: function(theme) {
                                    return theme.typography.h2.fontSize;
                                },
                                children: title
                            })
                        }),
                        additionalComponent && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                            mb: {
                                xs: 3
                            },
                            children: additionalComponent
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                    item: true,
                    xs: 12,
                    children: children
                })
            ]
        })
    });
};


;// CONCATENATED MODULE: ./src/components/CaregiverProfile/Sections/AboutCaregiverSection.tsx




var AboutCaregiverSection = function(param) {
    var firstName = param.firstName, experienceSummary = param.experienceSummary, isVaccinated = param.isVaccinated, yearsOfExperience = param.yearsOfExperience, isAiAssistedBio = param.isAiAssistedBio;
    var isDesktop = (0,useMediaQuery/* default */.Z)(function(theme) {
        return theme.breakpoints.up("md");
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Section, {
        displayDivider: !isDesktop,
        title: "About ".concat(firstName),
        useH1Variant: true,
        headerBottomMargin: 1,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AboutCaregiver, {
            isVaccinated: isVaccinated,
            yearsOfExperience: yearsOfExperience,
            experienceSummary: experienceSummary,
            isAiAssistedBio: isAiAssistedBio
        })
    });
};


// EXTERNAL MODULE: ./node_modules/dayjs/plugin/customParseFormat.js
var customParseFormat = __webpack_require__(10285);
var customParseFormat_default = /*#__PURE__*/__webpack_require__.n(customParseFormat);
// EXTERNAL MODULE: ./node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__(27484);
var dayjs_min_default = /*#__PURE__*/__webpack_require__.n(dayjs_min);
;// CONCATENATED MODULE: ./src/components/CaregiverProfile/Availability.tsx




var Availability = function(param) {
    var firstName = param.firstName, recurringAvailability = param.recurringAvailability;
    dayjs_min_default().extend((customParseFormat_default()));
    var schedule = [];
    if (recurringAvailability.dayList) {
        // Cast into map, so each day does not have to be used as a separate type, makes it iterable
        var dayList = new Map(Object.entries(recurringAvailability === null || recurringAvailability === void 0 ? void 0 : recurringAvailability.dayList));
        dayList.forEach(function(singleDay, dayName) {
            var ref;
            var dayRanges = [];
            singleDay === null || singleDay === void 0 ? void 0 : (ref = singleDay.blocks) === null || ref === void 0 ? void 0 : ref.forEach(function(block) {
                var start = dayjs_min_default()(block.start, "HH:mm:ss").format("h:mm A");
                var end = dayjs_min_default()(block.end, "HH:mm:ss").format("h:mm A");
                dayRanges.push("".concat(start, "–").concat(end));
            });
            if (dayRanges.length > 0) {
                schedule.push({
                    day: dayName.slice(0, 3),
                    // Delimiter for multiple time ranges
                    timeRange: dayRanges.join(", ")
                });
            }
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
        item: true,
        xs: 12,
        "data-testid": "availability-container",
        children: schedule.length > 0 ? schedule.map(function(param) {
            var timeRange = param.timeRange, day = param.day;
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                display: "flex",
                mb: 2,
                "data-testid": "".concat(day, "-schedule"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        variant: "h4",
                        width: "48px",
                        textTransform: "capitalize",
                        children: day
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        variant: "body2",
                        ml: 2,
                        children: timeRange
                    })
                ]
            }, day);
        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
            variant: "body2",
            children: [
                "Send ",
                firstName,
                " a message."
            ]
        })
    });
};
/* harmony default export */ var CaregiverProfile_Availability = (Availability);

;// CONCATENATED MODULE: ./src/components/CaregiverProfile/Sections/AvailabilitySection.tsx



var AvailabilitySection = function(param) {
    var firstName = param.firstName, recurringAvailability = param.recurringAvailability;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Section, {
        displayDivider: true,
        title: "Contact ".concat(firstName, " to check their availability"),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CaregiverProfile_Availability, {
            firstName: firstName,
            recurringAvailability: recurringAvailability
        })
    });
};
/* harmony default export */ var Sections_AvailabilitySection = (AvailabilitySection);

// EXTERNAL MODULE: ./src/components/Breadcrumbs.tsx
var Breadcrumbs = __webpack_require__(22284);
;// CONCATENATED MODULE: ./src/components/CaregiverProfile/Sections/BreadcrumbsSection.tsx



var BreadcrumbsSection = function(param) {
    var breadcrumbs = param.breadcrumbs;
    var isDesktop = (0,useMediaQuery/* default */.Z)(function(theme) {
        return theme.breakpoints.up("md");
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
        component: "section",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
            pt: {
                xs: 1,
                sm: 3
            },
            mb: {
                xs: 1,
                sm: 3
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                maxWidth: "md",
                disableGutters: isDesktop,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Breadcrumbs/* default */.Z, {
                    breadcrumbs: breadcrumbs
                })
            })
        })
    });
};
/* harmony default export */ var Sections_BreadcrumbsSection = (BreadcrumbsSection);

// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/@mui/material/Link/Link.js + 2 modules
var Link = __webpack_require__(23795);
// EXTERNAL MODULE: ./node_modules/@care/react-component-lib/dist/components/ProfileAvatar/ProfileAvatar.js + 3 modules
var ProfileAvatar = __webpack_require__(90346);
// EXTERNAL MODULE: ./node_modules/@care/react-component-lib/dist/components/Rating/Rating.js + 7 modules
var Rating = __webpack_require__(37918);
// EXTERNAL MODULE: ./src/utils/getUserInitials.ts
var getUserInitials = __webpack_require__(7772);
;// CONCATENATED MODULE: ./src/components/CaregiverProfile/SimilarCaregivers.tsx





var SimilarCaregivers = function(param) {
    var profiles = param.profiles;
    var profilesToDisplay = profiles.filter(function(profile) {
        return profile.seoProfileURL;
    }).slice(0, 5);
    var _imageURL, _avgReviewRating;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
        maxWidth: "md",
        disableGutters: true,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                mb: 3,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    variant: "h2",
                    children: "Similar caregivers nearby"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                container: true,
                columnGap: {
                    xs: 2,
                    md: 4
                },
                rowGap: 2,
                children: profilesToDisplay.map(function(profile) {
                    var ref;
                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                        item: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: profile.seoProfileURL,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                href: profile.seoProfileURL,
                                underline: "none",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "center",
                                    "data-testid": "similar-profiles",
                                    px: 1.5,
                                    rowGap: 0.5,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ProfileAvatar/* default */.Z, {
                                            alt: profile.member.displayName,
                                            src: (_imageURL = profile.member.imageURL) !== null && _imageURL !== void 0 ? _imageURL : undefined,
                                            size: "xLarge",
                                            mb: 1,
                                            children: (0,getUserInitials/* default */.Z)(profile.member.displayName)
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                            variant: "h4",
                                            color: "primary",
                                            children: profile.member.displayName
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Rating/* default */.Z, {
                                            name: "size-large",
                                            size: "small",
                                            defaultValue: (_avgReviewRating = profile.avgReviewRating) !== null && _avgReviewRating !== void 0 ? _avgReviewRating : undefined,
                                            readOnly: true
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                            variant: "info1",
                                            color: "secondary",
                                            children: (ref = profile.member.address) === null || ref === void 0 ? void 0 : ref.city
                                        })
                                    ]
                                })
                            })
                        })
                    }, profile.member.displayName);
                })
            })
        ]
    });
};


;// CONCATENATED MODULE: ./src/components/CaregiverProfile/Sections/SimilarCaregiversSection.tsx




var SimilarCaregiverSection = function(param) {
    var profiles = param.profiles;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
        item: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
            component: "section",
            mt: {
                xs: 2,
                lg: 4
            },
            width: "100%",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(SimilarCaregivers, {
                    profiles: profiles
                })
            ]
        })
    });
};


// EXTERNAL MODULE: ./node_modules/@mui/material/Button/Button.js + 3 modules
var Button = __webpack_require__(69417);
// EXTERNAL MODULE: ./src/lib/analyticsHelper.tsx
var analyticsHelper = __webpack_require__(883);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/exports.js
var esm_exports = __webpack_require__(64487);
// EXTERNAL MODULE: ./node_modules/@apollo/client/react/hooks/useMutation.js
var useMutation = __webpack_require__(50319);
// EXTERNAL MODULE: ./src/API/caregiverDetail.ts + 1 modules
var caregiverDetail = __webpack_require__(87279);
// EXTERNAL MODULE: ./src/__generated__/globalTypes.ts
var globalTypes = __webpack_require__(79967);
;// CONCATENATED MODULE: ./src/components/hooks/useReviewShortLink.tsx








var useReviewShortLink = function(param) {
    var publicId = param.publicId, serviceShortName = param.serviceShortName;
    var ref = (0,react.useState)(""), shortURL = ref[0], setShortURL = ref[1];
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(caregiverDetail/* GET_REVIEW_SHORT_LINK_CREATE */.uh), 1), reviewShortURL = ref1[0];
    (0,react.useEffect)(function() {
        var fetchShortUrl = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function() {
                var providerCareType, data, error;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                2,
                                ,
                                3
                            ]);
                            providerCareType = serviceShortName || globalTypes/* ReviewInfoCareType.CHILD_CARE */.RU.CHILD_CARE;
                            return [
                                4,
                                reviewShortURL({
                                    variables: {
                                        input: {
                                            providerCareType: providerCareType,
                                            publicId: publicId,
                                            refer: "rar"
                                        }
                                    }
                                })
                            ];
                        case 1:
                            data = _state.sent().data;
                            if (data && data.reviewShortLinkCreate.__typename === "ReviewShortLinkCreatePayload") {
                                setShortURL(data.reviewShortLinkCreate.shortUrl);
                            }
                            return [
                                3,
                                3
                            ];
                        case 2:
                            error = _state.sent();
                            (0,esm_exports/* captureException */.Tb)(error);
                            return [
                                3,
                                3
                            ];
                        case 3:
                            return [
                                2
                            ];
                    }
                });
            });
            return function fetchShortUrl() {
                return _ref.apply(this, arguments);
            };
        }();
        fetchShortUrl();
    }, [
        reviewShortURL,
        publicId,
        serviceShortName
    ]);
    return shortURL;
};
/* harmony default export */ var hooks_useReviewShortLink = (useReviewShortLink);

;// CONCATENATED MODULE: ./src/components/CaregiverProfile/WriteReviewButton.tsx




var WriteReviewButton = function(param) {
    var publicId = param.publicId, serviceShortName = param.serviceShortName;
    var shortUrl = hooks_useReviewShortLink({
        publicId: publicId,
        serviceShortName: serviceShortName
    });
    if (!shortUrl) {
        return null;
    }
    var handleRequestReview = function(e) {
        var amplitudeData = {
            cta_text: e.target.textContent,
            cta_type: "button"
        };
        (0,analyticsHelper/* trackAmplitudeEvent */.rG)(analyticsHelper/* AmplitudeEvent.seoFeatureInteracted */.Sj.seoFeatureInteracted, amplitudeData);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
            color: "secondary",
            variant: "outlined",
            onClick: handleRequestReview,
            href: shortUrl,
            component: "a",
            rel: "nofollow",
            children: "Write a review"
        })
    });
};
/* harmony default export */ var CaregiverProfile_WriteReviewButton = (WriteReviewButton);

// EXTERNAL MODULE: ./node_modules/@care/react-component-lib/dist/components/OverallRating/OverallRating.js
var OverallRating = __webpack_require__(14733);
// EXTERNAL MODULE: ./node_modules/@care/react-icons/dist/Icon24UtilityChevronRight.js
var Icon24UtilityChevronRight = __webpack_require__(16178);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@care/react-component-lib/dist/components/Tag/Tag.js
var Tag = __webpack_require__(96670);
;// CONCATENATED MODULE: ./src/components/CaregiverProfile/ReviewCard.tsx








/**
 * Given a full name (first and last) returns a names' initials
 *
 * @param fullname string
 * @returns string
 */ var getInitialsFromName = function(fullname) {
    if (fullname) {
        var nameBits = fullname.split(" ");
        if (nameBits.length === 1) {
            return "".concat(nameBits[0][0]).toUpperCase();
        }
        if (nameBits.length > 1) {
            return "".concat(nameBits[0][0]).concat(nameBits[nameBits.length - 1][0]).toUpperCase();
        }
    }
    return "";
};
/**
 * Renders the `Review` content from a reviewee. This will be used in the CaregiverProfilePage in the
initial page render, and the All Reviews Actionsheet.
 */ var ReviewCard = /*#__PURE__*/ (0,react.forwardRef)(function(_param, ref) {
    var review = _param.review, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "review"
    ]);
    var _$ref;
    var rating = review.ratings.find(function(obj) {
        return obj.type === globalTypes/* ReviewInfoRatingType.OVERALL */.F1.OVERALL;
    });
    var reviewDate = new Date(review.createTime).toLocaleDateString();
    var _displayName, _displayName1, _displayName2;
    var component = /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, rest), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                container: true,
                direction: "row",
                alignItems: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                        item: true,
                        mr: 1,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProfileAvatar/* default */.Z, {
                            size: "medium",
                            src: ((_$ref = review.reviewer.imageURL) === null || _$ref === void 0 ? void 0 : _$ref.toString()) || undefined,
                            alt: "Profile image of ".concat((_displayName = review.reviewer.displayName) !== null && _displayName !== void 0 ? _displayName : "Care member"),
                            children: getInitialsFromName((_displayName1 = review.reviewer.displayName) !== null && _displayName1 !== void 0 ? _displayName1 : "Care member")
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                        item: true,
                        ml: 1,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            children: (_displayName2 = review.reviewer.displayName) !== null && _displayName2 !== void 0 ? _displayName2 : "Care member"
                        })
                    })
                ]
            }),
            (Boolean(rating === null || rating === void 0 ? void 0 : rating.value) || Boolean(review.verifiedByCare)) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                container: true,
                direction: "row",
                alignItems: "center",
                mt: 1,
                children: [
                    (rating === null || rating === void 0 ? void 0 : rating.value) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                        item: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Rating/* default */.Z, {
                            defaultValue: rating === null || rating === void 0 ? void 0 : rating.value,
                            size: "small",
                            readOnly: true
                        })
                    }),
                    review.verifiedByCare && /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                        item: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Tag/* default */.Z, {
                            type: "green",
                            children: "Verified Booking by Care"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                container: true,
                item: true,
                mt: 1,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                    variant: "info1",
                    color: "secondary",
                    children: [
                        "Reviewed on ",
                        reviewDate
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                container: true,
                item: true,
                mt: 1,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    variant: "body2",
                    children: review === null || review === void 0 ? void 0 : review.description.originalText
                })
            })
        ]
    }));
    return ref ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
        container: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
            ref: ref,
            children: component
        })
    }) : component;
});


;// CONCATENATED MODULE: ./src/components/CaregiverProfile/MostRecentReview.tsx







var MostRecentReview = function(param) {
    var reviews = param.reviews, averageRatings = param.averageRatings, totalReviews = param.totalReviews, setOpenModal = param.setOpenModal, openModal = param.openModal;
    // Find the review with a rating equal to or above 3, otherwise return the latest review
    var getLatestReview = function() {
        var latestReview = reviews.find(function(review) {
            return review.ratings.find(function(rating) {
                return rating.type === globalTypes/* ReviewInfoRatingType.OVERALL */.F1.OVERALL && rating.value >= 3;
            });
        });
        return latestReview !== null && latestReview !== void 0 ? latestReview : reviews[0];
    };
    var showAllReviews = function(event) {
        event.preventDefault();
        var amplitudeData = {
            feature_name: "Reviews Modal"
        };
        (0,analyticsHelper/* trackAmplitudeEvent */.rG)(analyticsHelper/* AmplitudeEvent.seoFeatureInteracted */.Sj.seoFeatureInteracted, amplitudeData);
        setOpenModal(!openModal);
    };
    var latestReview = getLatestReview();
    var ref;
    var averageRating = (ref = averageRatings.find(function(rating) {
        return rating.type === globalTypes/* ReviewInfoRatingType.OVERALL */.F1.OVERALL;
    })) !== null && ref !== void 0 ? ref : averageRatings[0];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
        item: true,
        xs: 12,
        children: [
            averageRating && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                mb: 2,
                "data-testid": "unified-profile-overall-rating",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OverallRating/* default */.Z, {
                    overallRating: Number(averageRating.value.toFixed(1)),
                    totalReviews: totalReviews
                })
            }),
            latestReview && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                mb: {
                    xs: 2,
                    md: 4
                },
                "data-testid": "unified-profile-latest-review",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ReviewCard, {
                    review: latestReview
                })
            }),
            reviews.length > 1 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* default */.Z, {
                sx: function(theme) {
                    return {
                        color: theme.palette.care.black,
                        backgroundColor: theme.palette.care.white,
                        border: "none",
                        padding: 0,
                        width: "100%",
                        display: "flex",
                        justifyContent: {
                            xs: "flex-start",
                            md: "space-between"
                        },
                        alignItems: "center",
                        "&:hover": {
                            cursor: "pointer",
                            color: theme.palette.secondaryButton.light
                        }
                    };
                },
                onClick: showAllReviews,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        variant: "h4",
                        component: "span",
                        children: "Read all reviews"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        pl: 1,
                        mt: 1,
                        component: "span",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon24UtilityChevronRight/* default */.Z, {})
                    })
                ]
            })
        ]
    });
};


;// CONCATENATED MODULE: ./src/components/CaregiverProfile/Sections/MostRecentReviewSection.tsx





var MostRecentReviewSection = function(param) {
    var reviews = param.reviews, averageRatings = param.averageRatings, totalReviews = param.totalReviews, setOpenModal = param.setOpenModal, openModal = param.openModal, publicId = param.publicId, serviceShortName = param.serviceShortName, firstName = param.firstName;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Section, {
        displayDivider: true,
        title: "Reviews",
        additionalComponent: publicId && /*#__PURE__*/ (0,jsx_runtime.jsx)(CaregiverProfile_WriteReviewButton, {
            publicId: publicId,
            serviceShortName: serviceShortName
        }),
        children: totalReviews ? /*#__PURE__*/ (0,jsx_runtime.jsx)(MostRecentReview, {
            reviews: reviews,
            averageRatings: averageRatings,
            totalReviews: totalReviews,
            setOpenModal: setOpenModal,
            openModal: openModal
        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
            variant: "body2",
            children: [
                "Be the first to write ",
                firstName,
                " a review!"
            ]
        })
    });
};


// EXTERNAL MODULE: ./node_modules/@mui/material/CardContent/CardContent.js + 1 modules
var CardContent = __webpack_require__(44267);
// EXTERNAL MODULE: ./node_modules/@care/react-icons/dist/Icon24InfoBgcFilled.js
var Icon24InfoBgcFilled = __webpack_require__(66871);
// EXTERNAL MODULE: ./node_modules/@care/react-component-lib/dist/components/Card/Card.js
var Card = __webpack_require__(37088);
// EXTERNAL MODULE: ./src/components/SafetyModalWrapper.tsx
var SafetyModalWrapper = __webpack_require__(6150);
;// CONCATENATED MODULE: ./src/components/CaregiverProfile/CareCheckBox.tsx







var CareCheckBox = function(param) {
    var firstName = param.firstName, caregiverStateCode = param.caregiverStateCode;
    var isMobileOrSmaller = (0,useMediaQuery/* default */.Z)(function(theme) {
        return theme.breakpoints.down("md");
    });
    var badgeText = isMobileOrSmaller ? "Completed a CareCheck" : "".concat(firstName, " completed a CareCheck");
    var ref = (0,react.useState)(false), openModal = ref[0], setOpenModal = ref[1];
    var handleBackgroundCheck = function() {
        setOpenModal(true);
        var amplitudeData = {
            feature_name: "background check banner"
        };
        (0,analyticsHelper/* trackAmplitudeEvent */.rG)(analyticsHelper/* AmplitudeEvent.seoFeatureInteracted */.Sj.seoFeatureInteracted, amplitudeData);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default */.Z, {
                variant: "outlined",
                sx: function(theme) {
                    return {
                        borderRadius: theme.spacing(2)
                    };
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CardContent/* default */.Z, {
                    sx: {
                        px: 3,
                        ":last-child": {
                            pb: 2
                        }
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                        container: true,
                        direction: "row",
                        alignItems: "center",
                        spacing: 2,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                item: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon24InfoBgcFilled/* default */.Z, {})
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                                item: true,
                                xs: true,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        variant: "h4",
                                        children: badgeText
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                        variant: "body3",
                                        children: [
                                            "This is the background check we require for all caregivers.",
                                            " ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                variant: "text",
                                                sx: function(theme) {
                                                    return {
                                                        textDecoration: "underline",
                                                        display: "inline",
                                                        height: "inherit",
                                                        fontSize: theme.typography.body3.fontSize,
                                                        textTransform: "none",
                                                        padding: 0
                                                    };
                                                },
                                                component: "button",
                                                onClick: handleBackgroundCheck,
                                                children: "Learn more"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SafetyModalWrapper/* SafetyModalWrapper */.S, {
                openModal: openModal,
                setOpenModal: setOpenModal,
                isCaregiverProfilePage: true,
                caregiverStateCode: caregiverStateCode
            })
        ]
    });
};


;// CONCATENATED MODULE: ./src/components/CaregiverProfile/Sections/SafetyCardSection.tsx



var SafetyCardSection = function(param) {
    var firstName = param.firstName, caregiverStateCode = param.caregiverStateCode;
    var isDesktop = (0,useMediaQuery/* default */.Z)(function(theme) {
        return theme.breakpoints.up("md");
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
        mt: 4,
        mb: {
            xs: 0,
            md: 4
        },
        component: "section",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
            maxWidth: "md",
            disableGutters: isDesktop,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                width: {
                    xs: "100%",
                    sm: "540px"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CareCheckBox, {
                    firstName: firstName,
                    caregiverStateCode: caregiverStateCode
                })
            })
        })
    });
};


// EXTERNAL MODULE: ./node_modules/@care/caregiver-profile-components/dist/components/SafetyCard/SafetyCard.js + 3 modules
var SafetyCard = __webpack_require__(8373);
// EXTERNAL MODULE: ./node_modules/@care/caregiver-profile-components/dist/types.js
var types = __webpack_require__(92905);
;// CONCATENATED MODULE: ./src/components/CaregiverProfile/Safety.tsx




var Safety = function(param) {
    var hasCareCheck = param.hasCareCheck;
    var careCheckText = "What's included in CareCheck?";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
        item: true,
        xs: 12,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                mb: {
                    xs: 2,
                    md: 3
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                    variant: "body2",
                    children: [
                        "Visit our",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                            href: "https://www.care.com/about/safety/",
                            target: "_blank",
                            variant: "body2",
                            children: " Safety Center "
                        }),
                        "to learn more.",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                            href: "https://help.care.com/families/s/article/What-is-a-CareCheck-1?language=en_US",
                            target: "_blank",
                            variant: "body2",
                            children: " ".concat(careCheckText)
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                item: true,
                xs: 12,
                sm: 9,
                md: 11,
                children: hasCareCheck && /*#__PURE__*/ (0,jsx_runtime.jsx)(SafetyCard/* default */.Z, {
                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon24InfoBgcFilled/* default */.Z, {}),
                    onButtonClick: function() {},
                    title: "CareCheck",
                    ctaType: SafetyCard/* SafetyCardCTAType.completed */.p.completed,
                    careCheckType: types/* BackgroundCheckType.CARE_CHECK */.Zx.CARE_CHECK
                })
            })
        ]
    });
};
/* harmony default export */ var CaregiverProfile_Safety = (Safety);

;// CONCATENATED MODULE: ./src/components/CaregiverProfile/Sections/SafetySection.tsx



var SafetySection = function(param) {
    var hasCareCheck = param.hasCareCheck;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Section, {
        displayDivider: true,
        title: "Safety",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CaregiverProfile_Safety, {
            hasCareCheck: hasCareCheck
        })
    });
};
/* harmony default export */ var Sections_SafetySection = (SafetySection);

// EXTERNAL MODULE: ./src/components/CaregiverZipCodeCTA.tsx
var CaregiverZipCodeCTA = __webpack_require__(94989);
;// CONCATENATED MODULE: ./src/components/CaregiverProfile/Sections/ZipCodeCTASection.tsx



var ZipCodeCTASection = function(param) {
    var enrollmentURL = param.enrollmentURL, serviceShortName = param.serviceShortName, areBreadcrumbsPresent = param.areBreadcrumbsPresent;
    var desktopMarginTop = areBreadcrumbsPresent ? -4 : 0;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
        mt: {
            xs: 0,
            sm: desktopMarginTop
        },
        mb: {
            xs: 0,
            sm: 3
        },
        component: "section",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
            maxWidth: "md",
            disableGutters: true,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                container: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                    item: true,
                    xs: 12,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CaregiverZipCodeCTA/* default */.Z, {
                        enrollmentURL: enrollmentURL,
                        serviceShortName: serviceShortName
                    })
                })
            })
        })
    });
};
/* harmony default export */ var Sections_ZipCodeCTASection = (ZipCodeCTASection);

// EXTERNAL MODULE: ./node_modules/@care/caregiver-profile-components/dist/components/AttributeList/AttributeList.js
var AttributeList = __webpack_require__(65006);
// EXTERNAL MODULE: ./node_modules/@care/react-icons/dist/Icon24UtilityCheckmark.js
var Icon24UtilityCheckmark = __webpack_require__(37315);
// EXTERNAL MODULE: ./src/utils/mapQualitiesAndServices.ts
var mapQualitiesAndServices = __webpack_require__(94627);
// EXTERNAL MODULE: ./src/constants.ts
var constants = __webpack_require__(42660);
;// CONCATENATED MODULE: ./src/components/CaregiverProfile/Qualifications.tsx






var Qualifications = function(param) {
    var activeProfile = param.activeProfile, educationDegrees = param.educationDegrees, firstName = param.firstName, languages = param.languages;
    var isMobile = (0,useMediaQuery/* default */.Z)(function(theme) {
        return theme.breakpoints.down("sm");
    });
    var getLanguages = function() {
        if (!languages) return [];
        return languages.reduce(function(languageList, language) {
            if (!language) return languageList;
            var formattedLanguage = language[0].toUpperCase() + language.slice(1).toLowerCase();
            languageList.push(formattedLanguage);
            return languageList;
        }, []);
    };
    var getEducation = function() {
        if (!educationDegrees) return [];
        return educationDegrees.reduce(function(educationDetailsList, educationDegree) {
            if (!educationDegree) return educationDetailsList;
            return educationDetailsList.concat(educationDegree.educationDetailsText);
        }, []);
    };
    var languageList = getLanguages();
    var educationList = getEducation();
    var qualities;
    var otherQualities;
    /* once all verticals are converted to explicitly listing 'additional details' and 'professional skills', we will switch to the 'new'
    variable method and remove the additional details extraction from qualities */ var newAdditionalDetails = null;
    var newProfessionalSkills = null;
    if (activeProfile.qualities) {
        if (activeProfile.__typename === "ChildCareCaregiverProfile") {
            qualities = activeProfile.qualities;
            otherQualities = activeProfile.otherQualities;
        } else if (activeProfile.__typename === "PetCareCaregiverProfile") {
            qualities = activeProfile.qualities;
            otherQualities = activeProfile.otherQualities;
        } else if (activeProfile.__typename === "SeniorCareCaregiverProfile") {
            qualities = activeProfile.qualities;
            otherQualities = activeProfile.otherQualities;
        } else if (activeProfile.__typename === "HouseKeepingCaregiverProfile") {
            qualities = activeProfile.qualities;
            otherQualities = activeProfile.otherQualities;
        } else if (activeProfile.__typename === "TutoringCaregiverProfile") {
            var ref, ref1;
            var newQualities = activeProfile.qualities;
            newAdditionalDetails = (ref = (0,mapQualitiesAndServices/* default */.Z)(newQualities === null || newQualities === void 0 ? void 0 : newQualities.additionalDetails)) === null || ref === void 0 ? void 0 : ref.sort();
            newProfessionalSkills = (ref1 = (0,mapQualitiesAndServices/* default */.Z)(newQualities === null || newQualities === void 0 ? void 0 : newQualities.professionalSkills)) === null || ref1 === void 0 ? void 0 : ref1.sort();
            otherQualities = activeProfile.otherQualities;
        }
    }
    var renderedQualities = (0,mapQualitiesAndServices/* default */.Z)(qualities);
    var additionalDetails = newAdditionalDetails || renderedQualities.filter(function(quality) {
        return constants/* ADDITIONAL_DETAILS.indexOf */.II.indexOf(quality) >= 0;
    }).sort();
    var professionalSkills = newProfessionalSkills || renderedQualities.filter(function(quality) {
        return constants/* ADDITIONAL_DETAILS.indexOf */.II.indexOf(quality) < 0;
    }).sort();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
        item: true,
        container: true,
        xs: 12,
        "data-testid": "qualification-section",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                container: true,
                item: true,
                xs: 12,
                sm: 7,
                direction: "column",
                children: [
                    educationList.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                        item: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                            mb: isMobile ? 2 : 3,
                            "data-testid": "education-section",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AttributeList/* default */.Z, {
                                content: educationList,
                                label: "Education"
                            })
                        })
                    }),
                    languageList.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                        item: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                            mb: {
                                xs: 3,
                                sm: 0
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AttributeList/* default */.Z, {
                                content: languageList,
                                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon24UtilityCheckmark/* default */.Z, {}),
                                label: "Languages"
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                item: true,
                xs: 12,
                sm: 5,
                children: [
                    activeProfile.__typename !== "HouseKeepingCaregiverProfile" && (professionalSkills.length === 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(AttributeList/* default */.Z, {
                        label: "Professional skills",
                        content: "Message ".concat(firstName, " to get details about their experience.")
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(AttributeList/* default */.Z, {
                        label: "Professional skills",
                        content: professionalSkills,
                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon24UtilityCheckmark/* default */.Z, {})
                    })),
                    otherQualities && otherQualities.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        mt: activeProfile.__typename !== "HouseKeepingCaregiverProfile" ? 3 : 0,
                        mb: 3,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AttributeList/* default */.Z, {
                            label: "Other Qualifications & Credentials",
                            content: otherQualities
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        mt: activeProfile.__typename !== "HouseKeepingCaregiverProfile" ? 3 : 0,
                        children: additionalDetails.length === 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(AttributeList/* default */.Z, {
                            label: "Additional details",
                            content: "".concat(firstName, " hasn't provided this information.")
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(AttributeList/* default */.Z, {
                            label: "Additional details",
                            content: additionalDetails,
                            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon24UtilityCheckmark/* default */.Z, {})
                        })
                    })
                ]
            })
        ]
    });
};


;// CONCATENATED MODULE: ./src/components/CaregiverProfile/Sections/QualitiesSection.tsx



var QualificationsSection = function(param) {
    var educationDegrees = param.educationDegrees, firstName = param.firstName, languages = param.languages, activeProfile = param.activeProfile;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Section, {
        title: "Qualifications",
        displayDivider: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Qualifications, {
            activeProfile: activeProfile,
            firstName: firstName,
            educationDegrees: educationDegrees,
            languages: languages
        })
    });
};
/* harmony default export */ var QualitiesSection = (QualificationsSection);

// EXTERNAL MODULE: ./node_modules/@care/caregiver-profile-components/dist/components/HiredBy/HiredBy.js + 2 modules
var HiredBy = __webpack_require__(88008);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@care/react-component-lib/dist/components/Badge/Badge.js
var Badge = __webpack_require__(23887);
// EXTERNAL MODULE: ./node_modules/@care/react-icons/dist/Icon24InfoPremiumFilled.js
var Icon24InfoPremiumFilled = __webpack_require__(1743);
;// CONCATENATED MODULE: ./src/components/CaregiverProfile/ProfileData.tsx









var badgesData = {
    PREMIUM: {
        testId: "premium-badge",
        tooltipText: "This is the premium badge",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon24InfoPremiumFilled/* default */.Z, {})
    },
    BACKGROUND_CHECK: {
        testId: "bgc-badge",
        tooltipText: "This is the background check badge",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon24InfoBgcFilled/* default */.Z, {}),
        text: "Background checked"
    }
};
/**
 * A collection of primary data about the caregiver such as name, neighborhood,
 * rating, and their relevant badges.
 */ var ProfileData = function(_param) {
    var displayName = _param.displayName, _badges = _param.badges, badges = _badges === void 0 ? [] : _badges, _badgeOrder = _param.badgeOrder, badgeOrder = _badgeOrder === void 0 ? [
        "PREMIUM",
        "BACKGROUND_CHECK"
    ] : _badgeOrder, _showBackgroundCheckText = _param.showBackgroundCheckText, showBackgroundCheckText = _showBackgroundCheckText === void 0 ? false : _showBackgroundCheckText, neighborhood = _param.neighborhood, rate = _param.rate, _duration = _param.duration, duration = _duration === void 0 ? "hour" : _duration, rating = _param.rating, experience = _param.experience, vertical = _param.vertical, careCheckDate = _param.careCheckDate, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "displayName",
        "badges",
        "badgeOrder",
        "showBackgroundCheckText",
        "neighborhood",
        "rate",
        "duration",
        "rating",
        "experience",
        "vertical",
        "careCheckDate"
    ]);
    var sortedBadges = badges.length > 0 ? badgeOrder.filter(function(badge) {
        return badges.includes(badge);
    }) : [];
    var showExperience = !rating && experience && experience > 0;
    var showNewToCare = !rating && !experience;
    var ref = (0,react.useState)({
        PREMIUM: false,
        BACKGROUND_CHECK: false
    }), tooltipsOpen = ref[0], setTooltipsOpen = ref[1];
    var handleTooltipOpen = function(badgeType) {
        setTooltipsOpen((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, tooltipsOpen), (0,_define_property/* default */.Z)({}, badgeType, !tooltipsOpen[badgeType])));
    };
    var getTipHtml = function(badgeType) {
        var badgeText;
        if (badgeType === "PREMIUM") {
            badgeText = "Premium";
        } else if (badgeType === "BACKGROUND_CHECK") {
            badgeText = careCheckDate && careCheckDate.length ? "CareCheck completed as of ".concat(careCheckDate) : "CareCheck completed";
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
            color: "inherit",
            "aria-label": "".concat(badgeType === null || badgeType === void 0 ? void 0 : badgeType.toLowerCase(), " tooltip"),
            variant: "body3",
            children: badgeText
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        container: true
    }, rest), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                item: true,
                container: true,
                alignItems: "center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                    variant: "h2",
                    component: "div",
                    children: [
                        displayName,
                        sortedBadges.length > 0 && sortedBadges.map(function(badgeType, index) {
                            if (!badgeType) return null;
                            if (badgeType === "BACKGROUND_CHECK" && showBackgroundCheckText) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                    display: "inline-flex",
                                    alignItems: "center",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.Z, {
                                            PopperProps: {
                                                disablePortal: true
                                            },
                                            title: getTipHtml(badgeType),
                                            placement: "bottom",
                                            arrow: true,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Badge/* default */.Z, {
                                                "data-testid": badgesData[badgeType].testId,
                                                onMouseOver: function() {
                                                    return handleTooltipOpen(badgeType);
                                                },
                                                icon: badgesData[badgeType].icon,
                                                sx: {
                                                    ml: 0.5,
                                                    mr: -1,
                                                    cursor: "pointer",
                                                    height: "100%",
                                                    position: "relative",
                                                    top: "3px"
                                                }
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                            component: "span",
                                            ml: 0.5,
                                            fontSize: function(theme) {
                                                return theme.typography.badge.fontSize;
                                            },
                                            color: function(theme) {
                                                return theme.palette.text.hint;
                                            },
                                            mt: 0.5,
                                            children: "Background checked"
                                        })
                                    ]
                                }, "badge-".concat(index + 1));
                            }
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.Z, {
                                PopperProps: {
                                    disablePortal: true
                                },
                                title: getTipHtml(badgeType),
                                placement: "bottom",
                                arrow: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Badge/* default */.Z, {
                                    "data-testid": badgesData[badgeType].testId,
                                    onMouseOver: function() {
                                        return handleTooltipOpen(badgeType);
                                    },
                                    icon: badgesData[badgeType].icon,
                                    sx: {
                                        ml: 0.5,
                                        mr: -1,
                                        cursor: "pointer",
                                        height: "100%",
                                        position: "relative",
                                        top: "3px"
                                    }
                                })
                            }, "badge-".concat(index + 1));
                        })
                    ]
                })
            }),
            neighborhood && /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                item: true,
                container: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    variant: "body2",
                    sx: function(theme) {
                        return (0,_define_property/* default */.Z)({}, theme.breakpoints.down("sm"), {
                            maxWidth: "162px"
                        });
                    },
                    children: neighborhood
                })
            }),
            rate !== undefined && rate > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                item: true,
                container: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                    variant: "h4",
                    component: "p",
                    whiteSpace: "nowrap",
                    children: [
                        "from $",
                        rate,
                        " per ",
                        duration !== null && duration !== void 0 ? duration : "hour"
                    ]
                })
            }),
            Boolean(rating === null || rating === void 0 ? void 0 : rating.value) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                item: true,
                container: true,
                alignItems: "center",
                pt: 0.5,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Rating/* default */.Z, {
                        readOnly: true,
                        size: "medium",
                        value: rating === null || rating === void 0 ? void 0 : rating.value,
                        precision: 0.1
                    }),
                    Boolean(rating === null || rating === void 0 ? void 0 : rating.count) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                        variant: "info1",
                        children: [
                            "(",
                            rating === null || rating === void 0 ? void 0 : rating.count,
                            ")"
                        ]
                    })
                ]
            }),
            !!showExperience && /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                item: true,
                container: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                    variant: "body2",
                    children: [
                        experience >= 10 ? "10+" : experience,
                        " ",
                        experience === 1 ? "year" : "years",
                        " of experience"
                    ]
                })
            }),
            showNewToCare && /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                item: true,
                container: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                    variant: "body2",
                    children: [
                        "New to ",
                        vertical || "Care"
                    ]
                })
            })
        ]
    }));
};

;// CONCATENATED MODULE: ./src/components/CaregiverProfile/JoinToContact.tsx



var JoinToContact = function(param) {
    var ctaText = param.ctaText, enrollmentURL = param.enrollmentURL;
    var handleJoinCTA = function(e) {
        var amplitudeDataCTA = {
            cta_text: e.currentTarget.textContent,
            cta_type: "button"
        };
        (0,analyticsHelper/* trackAmplitudeEvent */.rG)(analyticsHelper/* AmplitudeEvent.ctaInteracted */.Sj.ctaInteracted, amplitudeDataCTA);
        return true;
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
        href: enrollmentURL,
        color: "primary",
        variant: "contained",
        size: "large",
        onClick: handleJoinCTA,
        fullWidth: true,
        rel: "nofollow",
        children: ctaText
    });
};


;// CONCATENATED MODULE: ./src/components/CaregiverProfile/CaregiverCard.tsx









var CaregiverCard = function(param) {
    var address = param.address, badges = param.badges, baseHourlyRate = param.baseHourlyRate, displayName = param.displayName, enrollmentURL = param.enrollmentURL, hiredByCount = param.hiredByCount, neighborhood = param.neighborhood, profileImage = param.profileImage, revieweeMetrics = param.revieweeMetrics, experience = param.experience, slotProps = param.slotProps;
    var isMobile = (0,useMediaQuery/* default */.Z)(function(theme) {
        return theme.breakpoints.down("sm");
    });
    var isDesktop = (0,useMediaQuery/* default */.Z)(function(theme) {
        return theme.breakpoints.up("md");
    });
    var avgOverallRating = revieweeMetrics && revieweeMetrics.averageRatings.find(function(rating) {
        return rating.type === globalTypes/* ReviewInfoRatingType.OVERALL */.F1.OVERALL;
    });
    var mapBadgeList = function(badgeList) {
        if (badgeList === null) return [];
        return badgeList.map(function(badge) {
            switch(badge){
                case globalTypes/* CaregiverBadge.BACKGROUND_CHECK */.es.BACKGROUND_CHECK:
                    return "BACKGROUND_CHECK";
                case globalTypes/* CaregiverBadge.PREMIUM */.es.PREMIUM:
                    return "PREMIUM";
                default:
                    return undefined;
            }
        });
    };
    var formatCaregiverNeighborhood = function(param) {
        var caregiverNeighborhood = param.caregiverNeighborhood, caregiverAddress = param.caregiverAddress;
        if (caregiverNeighborhood && caregiverAddress) {
            return "".concat(caregiverNeighborhood.name, ", ").concat(caregiverAddress.city, ", ").concat(caregiverAddress.state, "  ").concat(caregiverAddress.zip);
        }
        if (caregiverAddress) {
            return "".concat(caregiverAddress.city, ", ").concat(caregiverAddress.state, " ").concat(caregiverAddress.zip);
        }
        return undefined;
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                bgcolor: function(theme) {
                    return theme.palette.background.latte;
                },
                py: isMobile ? "12px" : 3,
                component: "section",
                "data-testid": "caregiver-card",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                    maxWidth: "md",
                    disableGutters: isDesktop,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                        container: true,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                                container: true,
                                item: true,
                                spacing: isMobile ? 3 : 4,
                                md: 8,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                        item: true,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProfileAvatar/* default */.Z, (0,_object_spread/* default */.Z)({
                                            src: profileImage !== null && profileImage !== void 0 ? profileImage : undefined,
                                            size: isMobile ? "squareSmall" : "squareXLarge",
                                            variant: "square"
                                        }, slotProps === null || slotProps === void 0 ? void 0 : slotProps.profileAvatar))
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                        container: true,
                                        item: true,
                                        xs: true,
                                        justifyContent: "space-between",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                                            item: true,
                                            xs: true,
                                            md: 12,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ProfileData, {
                                                    badges: mapBadgeList(badges),
                                                    showBackgroundCheckText: isDesktop,
                                                    displayName: displayName,
                                                    experience: experience || undefined,
                                                    neighborhood: formatCaregiverNeighborhood({
                                                        caregiverNeighborhood: neighborhood,
                                                        caregiverAddress: address
                                                    }),
                                                    rate: typeof baseHourlyRate === "undefined" ? baseHourlyRate : parseInt(baseHourlyRate, 10),
                                                    rating: avgOverallRating ? {
                                                        count: revieweeMetrics.totalReviews,
                                                        value: avgOverallRating.value
                                                    } : undefined
                                                }),
                                                !isMobile && hiredByCount && hiredByCount.hiredCount > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                                    mt: 2,
                                                    "data-testid": "desktop-hiredby",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HiredBy/* default */.Z, {
                                                        count: hiredByCount.hiredCount,
                                                        bold: true
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }),
                            isDesktop && /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                container: true,
                                item: true,
                                md: 4,
                                justifyContent: "flex-end",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                    width: 300,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(JoinToContact, {
                                        ctaText: "Join to contact",
                                        enrollmentURL: enrollmentURL
                                    })
                                })
                            })
                        ]
                    })
                })
            }),
            isMobile && hiredByCount && hiredByCount.hiredCount > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                my: 2,
                "data-testid": "mobile-hiredby",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HiredBy/* default */.Z, {
                        count: hiredByCount.hiredCount,
                        bold: true
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var CaregiverProfile_CaregiverCard = (CaregiverCard);

// EXTERNAL MODULE: ./src/components/SeoGlobalNavbar.tsx
var SeoGlobalNavbar = __webpack_require__(8410);
// EXTERNAL MODULE: ./src/utils/getProviderMetadata.ts
var getProviderMetadata = __webpack_require__(56897);
// EXTERNAL MODULE: ./src/utils/generateEnrollmentUrl.ts + 1 modules
var generateEnrollmentUrl = __webpack_require__(85715);
;// CONCATENATED MODULE: ./src/components/CaregiverProfile/Sections/JoinToContactSection.tsx



var JoinToContactSection = function(param) {
    var ctaText = param.ctaText, enrollmentURL = param.enrollmentURL;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
        width: "100%",
        component: "section",
        py: 3,
        position: "fixed",
        bottom: 0,
        zIndex: 2,
        sx: {
            background: "var(--background-white-gradient, linear-gradient(180deg, rgba(255, 255, 255, 0.00) 0%, rgba(255, 255, 255, 0.65) 24.48%, #FFF 50%, #FFF 100%))"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
            maxWidth: "md",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                maxWidth: "300px",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(JoinToContact, {
                    ctaText: ctaText,
                    enrollmentURL: enrollmentURL
                })
            })
        })
    });
};


// EXTERNAL MODULE: ./node_modules/@mui/material/Drawer/Drawer.js + 2 modules
var Drawer = __webpack_require__(77533);
// EXTERNAL MODULE: ./node_modules/@mui/material/IconButton/IconButton.js + 1 modules
var IconButton = __webpack_require__(93946);
// EXTERNAL MODULE: ./node_modules/@care/react-icons/dist/Icon24UtilityClose.js
var Icon24UtilityClose = __webpack_require__(82843);
;// CONCATENATED MODULE: ./src/components/CaregiverProfile/ReviewsModal.tsx








var ReviewsModal = function(param) {
    var openModal = param.openModal, setOpenModal = param.setOpenModal, reviews = param.reviews, averageRatings = param.averageRatings, totalReviews = param.totalReviews;
    var isMobileOrSmaller = (0,useMediaQuery/* default */.Z)(function(theme) {
        return theme.breakpoints.down("md");
    });
    var ref;
    var averageRating = (ref = averageRatings.find(function(rating) {
        return rating.type === globalTypes/* ReviewInfoRatingType.OVERALL */.F1.OVERALL;
    })) !== null && ref !== void 0 ? ref : averageRatings[0];
    var allReviews = function() {
        return reviews.map(function(review) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                mb: 2,
                "data-testid": "reviews-modal-review",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ReviewCard, {
                    review: review
                })
            }, "review-".concat(review.id));
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Drawer/* default */.ZP, {
        anchor: isMobileOrSmaller ? "bottom" : "right",
        open: openModal,
        onClose: function() {
            return setOpenModal(!openModal);
        },
        "data-testid": "modal-drawer",
        sx: function(theme) {
            return {
                "& .MuiDrawer-paper": (0,_define_property/* default */.Z)({
                    p: theme.spacing(2, 0, 0, 0)
                }, theme.breakpoints.up("md"), {
                    borderRadius: 0
                }),
                "& .MuiDrawer-paperAnchorBottom": {
                    maxHeight: "75%"
                }
            };
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
            maxWidth: "md",
            sx: {
                py: 0,
                px: {
                    xs: 3,
                    md: 4.5
                }
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                container: true,
                item: true,
                xs: 12,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        width: "100%",
                        display: "flex",
                        justifyContent: "flex-end",
                        pb: 4,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                            position: "fixed",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                                onClick: function() {
                                    return setOpenModal(!openModal);
                                },
                                size: "large",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon24UtilityClose/* default */.Z, {})
                            })
                        })
                    }),
                    averageRating && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        pb: 2,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OverallRating/* default */.Z, {
                            overallRating: Number(averageRating.value.toFixed(1)),
                            totalReviews: totalReviews
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                        item: true,
                        xs: 12,
                        children: allReviews()
                    })
                ]
            })
        })
    });
};


// EXTERNAL MODULE: ./node_modules/@care/react-icons/dist/IconIllustrationSmallBaby.js
var IconIllustrationSmallBaby = __webpack_require__(48013);
// EXTERNAL MODULE: ./node_modules/@care/react-icons/dist/IconIllustrationSmallToddler.js
var IconIllustrationSmallToddler = __webpack_require__(16809);
// EXTERNAL MODULE: ./node_modules/@care/react-icons/dist/IconIllustrationSmallTyke.js
var IconIllustrationSmallTyke = __webpack_require__(21714);
// EXTERNAL MODULE: ./node_modules/@care/react-icons/dist/IconIllustrationSmallKid.js
var IconIllustrationSmallKid = __webpack_require__(32);
// EXTERNAL MODULE: ./node_modules/@care/react-icons/dist/IconIllustrationSmallPreteenPlus.js
var IconIllustrationSmallPreteenPlus = __webpack_require__(37832);
// EXTERNAL MODULE: ./src/utils/payRangeHelper.ts
var payRangeHelper = __webpack_require__(32150);
;// CONCATENATED MODULE: ./src/components/CaregiverProfile/CanHelpWith.tsx




var CanHelpWith = function(param) {
    var firstName = param.firstName, canHelpWithList = param.canHelpWithList;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
        item: true,
        xs: 12,
        sm: 5,
        children: canHelpWithList.length === 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(AttributeList/* default */.Z, {
            label: "Can help with",
            content: "".concat(firstName, " hasn't provided this information.")
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(AttributeList/* default */.Z, {
            label: "Can help with",
            content: canHelpWithList,
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon24UtilityCheckmark/* default */.Z, {})
        })
    });
};


;// CONCATENATED MODULE: ./src/components/CaregiverProfile/ChildCareServices.tsx







var AGE_GROUP_MAP = {
    NEWBORN: {
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconIllustrationSmallBaby/* default */.Z, {
            size: "48px"
        }),
        text: "0-11 mo"
    },
    TODDLER: {
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconIllustrationSmallToddler/* default */.Z, {
            size: "48px"
        }),
        text: "1-3 yrs"
    },
    EARLY_SCHOOL: {
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconIllustrationSmallTyke/* default */.Z, {
            size: "48px"
        }),
        text: "4-5 yrs"
    },
    ELEMENTARY_SCHOOL: {
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconIllustrationSmallKid/* default */.Z, {
            size: "48px"
        }),
        text: "6-11 yrs"
    },
    TEEN: {
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconIllustrationSmallPreteenPlus/* default */.Z, {
            size: "48px"
        }),
        text: "12+ yrs"
    }
};
var ChildCareServices = function(param) {
    var childCareProfile = param.childCareProfile, merchandizedJobInterests = param.merchandizedJobInterests, firstName = param.firstName;
    var ref, ref1;
    var numberOfChildren = childCareProfile.numberOfChildren, ageGroups = childCareProfile.ageGroups, rates = childCareProfile.rates, recurringRate = childCareProfile.recurringRate, supportedServices = childCareProfile.supportedServices;
    var fromRate = recurringRate === null || recurringRate === void 0 ? void 0 : (ref = recurringRate.hourlyRateFrom) === null || ref === void 0 ? void 0 : ref.amount;
    var toRate = recurringRate === null || recurringRate === void 0 ? void 0 : (ref1 = recurringRate.hourlyRateTo) === null || ref1 === void 0 ? void 0 : ref1.amount;
    var renderedServices = (0,mapQualitiesAndServices/* default */.Z)((0,_object_spread/* default */.Z)({}, supportedServices, merchandizedJobInterests)).sort();
    var renderedRates = [];
    if (!numberOfChildren) {
        renderedRates = rates;
    } else {
        renderedRates = rates.filter(function(rate) {
            return rate.numberOfChildren <= numberOfChildren || rate.isDefaulted === false;
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
        item: true,
        container: true,
        xs: 12,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                item: true,
                xs: 12,
                sm: 7,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        variant: "h4",
                        component: "p",
                        children: "Age groups"
                    }),
                    numberOfChildren === null && ageGroups.length === 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        mt: 1,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                            variant: "body2",
                            children: [
                                "Message ",
                                firstName,
                                " to get details about their experience."
                            ]
                        })
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                display: "flex",
                                textAlign: "center",
                                flexWrap: "wrap",
                                children: ageGroups.map(function(group) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                        my: 1,
                                        mr: {
                                            xs: 2,
                                            sm: 3
                                        },
                                        display: "flex",
                                        flexDirection: "column",
                                        children: [
                                            AGE_GROUP_MAP[group].icon,
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                variant: "body3",
                                                pt: 1,
                                                children: AGE_GROUP_MAP[group].text
                                            })
                                        ]
                                    }, group);
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                    variant: "body2",
                                    children: [
                                        "Willing to care for up to ",
                                        numberOfChildren,
                                        numberOfChildren === 1 ? " child" : " children"
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                        mt: 3,
                        mb: {
                            xs: 3,
                            sm: 0
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                variant: "h4",
                                component: "p",
                                pb: 1,
                                children: "Rates"
                            }),
                            !fromRate && !toRate && rates.length === 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                children: [
                                    firstName,
                                    " hasn't provided this information."
                                ]
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                maxWidth: 326,
                                children: [
                                    fromRate && toRate && (Number(fromRate) > 0 || Number(toRate) > 0) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                        display: "flex",
                                        justifyContent: "space-between",
                                        pb: 1,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                variant: "body2",
                                                children: "Recurring jobs"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                                variant: "h4",
                                                component: "p",
                                                children: [
                                                    (0,payRangeHelper/* default */.Z)(toRate, fromRate),
                                                    "/hr"
                                                ]
                                            })
                                        ]
                                    }),
                                    renderedRates.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                variant: "body2",
                                                pb: 1,
                                                children: "One time jobs"
                                            }),
                                            renderedRates.map(function(rate) {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                                    display: "flex",
                                                    justifyContent: "space-between",
                                                    sx: {
                                                        ":not(:last-child)": {
                                                            pb: 1
                                                        }
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                            variant: "body2",
                                                            color: "secondary",
                                                            children: rate.numberOfChildren === 1 ? "1 child" : "".concat(rate.numberOfChildren, " children")
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                                            variant: "h4",
                                                            component: "p",
                                                            children: [
                                                                "$",
                                                                rate.hourlyRate.amount,
                                                                "/hr"
                                                            ]
                                                        })
                                                    ]
                                                }, rate.numberOfChildren + rate.hourlyRate.amount);
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CanHelpWith, {
                firstName: firstName,
                canHelpWithList: renderedServices
            })
        ]
    });
};


;// CONCATENATED MODULE: ./src/components/CaregiverProfile/ServicesOffered.tsx






var ServicesOffered = function(param) {
    var firstName = param.firstName, supportedServices = param.supportedServices;
    var renderedServices = (0,mapQualitiesAndServices/* default */.Z)((0,_object_spread/* default */.Z)({}, supportedServices)).sort();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
        children: renderedServices.length === 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(AttributeList/* default */.Z, {
            label: "Services offered",
            content: "".concat(firstName, " hasn't provided this information.")
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(AttributeList/* default */.Z, {
            label: "Services offered",
            content: renderedServices,
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon24UtilityCheckmark/* default */.Z, {})
        })
    });
};


;// CONCATENATED MODULE: ./src/components/CaregiverProfile/PetCareServices.tsx









var PetCareServices = function(param) {
    var petCareProfile = param.petCareProfile, merchandizedJobInterests = param.merchandizedJobInterests, firstName = param.firstName;
    var ref, ref1;
    var petSpecies = petCareProfile.petSpecies, supportedServices = petCareProfile.supportedServices, recurringRate = petCareProfile.recurringRate, rates = petCareProfile.rates;
    var renderedSpecies = (0,mapQualitiesAndServices/* default */.Z)((0,_object_spread/* default */.Z)({}, petSpecies)).sort();
    var renderedCanHelpWith = (0,mapQualitiesAndServices/* default */.Z)((0,_object_spread/* default */.Z)({}, merchandizedJobInterests)).sort();
    var toRate = (recurringRate === null || recurringRate === void 0 ? void 0 : (ref = recurringRate.hourlyRateTo) === null || ref === void 0 ? void 0 : ref.amount) || "0";
    var fromRate = (recurringRate === null || recurringRate === void 0 ? void 0 : (ref1 = recurringRate.hourlyRateFrom) === null || ref1 === void 0 ? void 0 : ref1.amount) || "0";
    var rateDisplayText = function(period) {
        return "".concat((0,payRangeHelper/* default */.Z)(toRate, fromRate), "/").concat(period);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
        item: true,
        container: true,
        xs: 12,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                item: true,
                xs: 12,
                sm: 7,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        children: renderedSpecies.length === 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(AttributeList/* default */.Z, {
                            label: "Pets",
                            content: "Message ".concat(firstName, " to get details about their experience.")
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(AttributeList/* default */.Z, {
                            label: "Pets",
                            content: renderedSpecies,
                            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon24UtilityCheckmark/* default */.Z, {})
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        mt: 3,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ServicesOffered, {
                            firstName: firstName,
                            supportedServices: supportedServices
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                        mt: 3,
                        mb: {
                            xs: 3,
                            sm: 0
                        },
                        maxWidth: 326,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                variant: "h4",
                                component: "p",
                                mb: 1,
                                children: "Rates"
                            }),
                            !fromRate && !toRate && rates.length === 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                children: [
                                    firstName,
                                    " hasn't provided this information."
                                ]
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                children: [
                                    (Number(fromRate) > 0 || Number(toRate) > 0) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                        display: "flex",
                                        justifyContent: "space-between",
                                        pb: 1,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                variant: "body2",
                                                children: "Recurring jobs"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                variant: "h4",
                                                component: "p",
                                                children: rateDisplayText("hr")
                                            })
                                        ]
                                    }),
                                    rates.map(function(rate) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                            display: "flex",
                                            justifyContent: "space-between",
                                            sx: {
                                                ":not(:last-child)": {
                                                    pb: 1
                                                }
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                    variant: "body2",
                                                    children: rate.activity
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                                    variant: "h4",
                                                    component: "p",
                                                    children: [
                                                        "$",
                                                        rate.activityRate.amount,
                                                        "/",
                                                        rate.activityRateUnit
                                                    ]
                                                })
                                            ]
                                        }, "".concat(rate.activity, " - ").concat(rate.activityRateUnit));
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CanHelpWith, {
                firstName: firstName,
                canHelpWithList: renderedCanHelpWith
            })
        ]
    });
};


;// CONCATENATED MODULE: ./src/components/CaregiverProfile/SeniorCareServices.tsx







var SeniorCareServices = function(param) {
    var seniorCareProfile = param.seniorCareProfile, merchandizedJobInterests = param.merchandizedJobInterests, firstName = param.firstName;
    var ref, ref1;
    var supportedServices = seniorCareProfile.supportedServices, recurringRate = seniorCareProfile.recurringRate;
    var renderedCanHelpWith = (0,mapQualitiesAndServices/* default */.Z)((0,_object_spread/* default */.Z)({}, merchandizedJobInterests)).sort();
    var toRate = (recurringRate === null || recurringRate === void 0 ? void 0 : (ref = recurringRate.hourlyRateTo) === null || ref === void 0 ? void 0 : ref.amount) || "0";
    var fromRate = (recurringRate === null || recurringRate === void 0 ? void 0 : (ref1 = recurringRate.hourlyRateFrom) === null || ref1 === void 0 ? void 0 : ref1.amount) || "0";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
        item: true,
        container: true,
        xs: 12,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                item: true,
                xs: 12,
                sm: 7,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ServicesOffered, {
                        firstName: firstName,
                        supportedServices: supportedServices
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                        mt: 3,
                        mb: {
                            xs: 3,
                            sm: 0
                        },
                        maxWidth: 326,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                variant: "h4",
                                component: "p",
                                children: "Rates"
                            }),
                            !fromRate && !toRate ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                mt: 1,
                                children: [
                                    firstName,
                                    " hasn't provided this information."
                                ]
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                mt: 1,
                                children: (Number(fromRate) > 0 || Number(toRate) > 0) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                    display: "flex",
                                    justifyContent: "space-between",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                            variant: "body2",
                                            children: "Recurring jobs"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                            variant: "h4",
                                            component: "p",
                                            children: [
                                                (0,payRangeHelper/* default */.Z)(toRate, fromRate),
                                                "/hr"
                                            ]
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CanHelpWith, {
                firstName: firstName,
                canHelpWithList: renderedCanHelpWith
            })
        ]
    });
};


// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
;// CONCATENATED MODULE: ./src/utils/convertSubjectsToStrings.ts
// this is a hard-coded table rather than a dynamically generated display value because of the presence of a variety of acronyms
var GQL_TUTORING_SUBJECTS_TABLE = {
    MATH_SUBJECT_ALGEBRA: "Math - Algebra 1",
    MATH_SUBJECT_CALCULUS: "Math - Calculus",
    MATH_SUBJECT_ELEMENTARY_SCHOOL_MATH: "Math - Elementary School Math",
    MATH_SUBJECT_GEOMETRY: "Math - Geometry",
    MATH_SUBJECT_HIGH_SCHOOL_MATH: "Math - High School Math",
    MATH_SUBJECT_MIDDLE_SCHOOL_MATH: "Math - Middle School Math",
    MATH_SUBJECT_PRE_CALCULUS: "Math - Pre-Calculus",
    ENGLISH_SUBJECT_ESL: "English - ESL",
    ENGLISH_SUBJECT_GRAMMAR: "English - Grammar",
    ENGLISH_SUBJECT_LANGUAGE_ARTS_K6: "English - Language Arts K-6",
    ENGLISH_SUBJECT_LITERATURE: "English - Literature",
    ENGLISH_SUBJECT_READING: "English - Reading",
    ENGLISH_SUBJECT_WRITING: "English - Writing",
    SCIENCE_SUBJECT_BIOLOGY: "Science - Biology",
    SCIENCE_SUBJECT_CHEMISTRY: "Science - Chemistry",
    SCIENCE_SUBJECT_EARTH_SCIENCE: "Science - Earth Science",
    SCIENCE_SUBJECT_ELEMENTARY_SCIENCE: "Science - Elementary Science",
    SCIENCE_SUBJECT_LIFE_SCIENCE: "Science - Life Science",
    SCIENCE_SUBJECT_MIDDLE_SCHOOL: "Science - Middle School",
    SCIENCE_SUBJECT_PHYSICS: "Science - Physics",
    SCIENCE_SUBJECT_PSYCHOLOGY: "Science - Psychology",
    TEST_PREP_SUBJECT_3RD_GRADE_SOL: "Test Prep - 3rd grade SOL",
    TEST_PREP_SUBJECT_5TH_GRADE_SOL: "Test Prep - 5th grade SOL",
    TEST_PREP_SUBJECT_ACT: "Test Prep - ACT",
    TEST_PREP_SUBJECT_ELEMENTARY_STANDARD_TESTING: "Test Prep - Elementary Standard Testing",
    TEST_PREP_SUBJECT_GED: "Test Prep - GED",
    TEST_PREP_SUBJECT_GMAT: "Test Prep - GMAT",
    TEST_PREP_SUBJECT_GRE: "Test Prep - GRE",
    TEST_PREP_SUBJECT_MIDDLE_SCHOOL_SOL: "Test Prep - Middle School SOL",
    TEST_PREP_SUBJECT_PRIVATE_SCHOOL_ENTRANCE: "Test Prep - Private School Entrance",
    TEST_PREP_SUBJECT_PSAT_TEST: "Test Prep - PSAT test",
    TEST_PREP_SUBJECT_SAT_MATH: "Test Prep - SAT Math",
    TEST_PREP_SUBJECT_SAT_VERBAL: "Test Prep - SAT Verbal",
    TEST_PREP_SUBJECT_TOEFL: "Test Prep - TOEFL",
    FOREIGN_LANGUAGE_SUBJECT_ARABIC: "Foreign Language - Arabic",
    FOREIGN_LANGUAGE_SUBJECT_CHINESE: "Foreign Language - Chinese",
    FOREIGN_LANGUAGE_SUBJECT_FRENCH: "Foreign Language - French",
    FOREIGN_LANGUAGE_SUBJECT_GERMAN: "Foreign Language - German",
    FOREIGN_LANGUAGE_SUBJECT_HINDI: "Foreign Language - Hindi",
    FOREIGN_LANGUAGE_SUBJECT_ITALIAN: "Foreign Language - Italian",
    FOREIGN_LANGUAGE_SUBJECT_JAPANESE: "Foreign Language - Japanese",
    FOREIGN_LANGUAGE_SUBJECT_LATIN: "Foreign Language - Latin",
    FOREIGN_LANGUAGE_SUBJECT_PORTUGUESE: "Foreign Language - Portuguese",
    FOREIGN_LANGUAGE_SUBJECT_RUSSIAN: "Foreign Language - Russian",
    FOREIGN_LANGUAGE_SUBJECT_SPANISH: "Foreign Language - Spanish",
    COMPUTERS_SUBJECT_ANDROID_APP_DEVELOPMENT: "Computers - Android App Development",
    COMPUTERS_SUBJECT_BASIC: "Computers - Basic",
    COMPUTERS_SUBJECT_C: "Computers - C",
    COMPUTERS_SUBJECT_CPP: "Computers - C++",
    COMPUTERS_SUBJECT_COMPUTER_BASICS: "Computers - Computer Basics",
    COMPUTERS_SUBJECT_COMPUTER_SCIENCE: "Computers - Computer Science",
    COMPUTERS_SUBJECT_HTML: "Computers - HTML",
    COMPUTERS_SUBJECT_INTERNET_SITE_DESIGN: "Computers - Internet Site Design",
    COMPUTERS_SUBJECT_IOS_APP_DEVELOPMENT: "Computers - iOS App Development",
    COMPUTERS_SUBJECT_JAVA: "Computers - Java",
    COMPUTERS_SUBJECT_JAVASCRIPT: "Computers - Javascript",
    COMPUTERS_SUBJECT_LINUX: "Computers - Linux",
    COMPUTERS_SUBJECT_MACINTOSH: "Computers - Macintosh",
    COMPUTERS_SUBJECT_MICROSOFT_ACCESS: "Computers - Microsoft Access",
    COMPUTERS_SUBJECT_MICROSOFT_EXCEL: "Computers - Microsoft Excel",
    COMPUTERS_SUBJECT_MICROSOFT_OFFICE: "Computers - Microsoft Office",
    COMPUTERS_SUBJECT_MICROSOFT_POWERPOINT: "Computers - Microsoft Powerpoint",
    COMPUTERS_SUBJECT_MICROSOFT_WINDOWS: "Computers - Microsoft Windows",
    COMPUTERS_SUBJECT_MICROSOFT_WORD: "Computers - Microsoft Word",
    COMPUTERS_SUBJECT_OUTLOOK: "Computers - Outllook",
    COMPUTERS_SUBJECT_PHOTOSHOP: "Computers - Photoshop",
    COMPUTERS_SUBJECT_PROGRAMMING: "Computers - Programming",
    COMPUTERS_SUBJECT_PYTHON: "Computers - Python",
    COMPUTERS_SUBJECT_VISUAL_BASIC: "Computers - Visual Basic",
    COMPUTERS_SUBJECT_WINDOWS: "Computers - Windows",
    ART_SUBJECT_ART_HISTORY: "Art - Art History",
    ART_SUBJECT_DRAWING: "Art - Drawing",
    ART_SUBJECT_PAINTING: "Art - Painting",
    ART_SUBJECT_PHOTOGRAPHY: "Art - Photography",
    MUSIC_DRAMA_SUBJECT_DRAMA_THEATER: "Music Drama - Drama & Theater",
    MUSIC_DRAMA_SUBJECT_GENERAL_MUSIC: "Music Drama - General Music",
    MUSIC_DRAMA_SUBJECT_SINGING: "Music Drama - Singing",
    MUSICAL_INSTRUMENTS_SUBJECT_CLARINET: "Musical Instruments - Clarinet",
    MUSICAL_INSTRUMENTS_SUBJECT_DRUMS: "Musical Instruments - Drums",
    MUSICAL_INSTRUMENTS_SUBJECT_FLUTE: "Musical Instruments - Flute",
    MUSICAL_INSTRUMENTS_SUBJECT_GUITAR: "Musical Instruments - Guitar",
    MUSICAL_INSTRUMENTS_SUBJECT_KEYBOARD: "Musical Instruments - Keyboard",
    MUSICAL_INSTRUMENTS_SUBJECT_PIANO: "Musical Instruments - Piano",
    MUSICAL_INSTRUMENTS_SUBJECT_SAXOPHONE: "Musical Instruments - Saxophone",
    MUSICAL_INSTRUMENTS_SUBJECT_TRUMPET: "Musical Instruments - Trumpet",
    MUSICAL_INSTRUMENTS_SUBJECT_VIOLIN: "Musical Instruments - Violin",
    DANCE_SUBJECT_BALLET: "Dance - Ballet",
    DANCE_SUBJECT_HIP_HOP: "Dance - Hip Hop",
    DANCE_SUBJECT_JAZZ: "Dance - Jazz",
    SPORTS_FITNESS_SUBJECT_BASEBALL: "Sports Fitness - Baseball",
    SPORTS_FITNESS_SUBJECT_BASKETBALL: "Sports Fitness - Basketball",
    SPORTS_FITNESS_SUBJECT_FIELD_HOCKEY: "Sports Fitness - Field Hockey",
    SPORTS_FITNESS_SUBJECT_FOOTBALL: "Sports Fitness - Football",
    SPORTS_FITNESS_SUBJECT_GYMNASTICS: "Sports Fitness - Gymnastics",
    SPORTS_FITNESS_SUBJECT_PERSONAL_TRAINING: "Sports Fitness - Personal Training",
    SPORTS_FITNESS_SUBJECT_RUNNING: "Sports Fitness - Running",
    SPORTS_FITNESS_SUBJECT_SOCCER: "Sports Fitness - Soccer",
    SPORTS_FITNESS_SUBJECT_SOFTBALL: "Sports Fitness - Softball",
    SPORTS_FITNESS_SUBJECT_SWIMMING: "Sports Fitness - Swimming",
    SPORTS_FITNESS_SUBJECT_TENNIS: "Sports Fitness - Tennis",
    SPORTS_FITNESS_SUBJECT_TRACK_AND_FIELD: "Sports Fitness - Track & Field",
    SPORTS_FITNESS_SUBJECT_VOLLEYBALL: "Sports Fitness - Volleyball",
    BUSINESS_SUBJECT_ACCOUNTING: "Business - Accounting",
    BUSINESS_SUBJECT_ECONOMICS: "Business - Economics",
    BUSINESS_SUBJECT_FINANCE: "Business - Finance",
    BUSINESS_SUBJECT_MARKETING: "Business - Marketing",
    BUSINESS_SUBJECT_ORGANIZATIONAL_BEHAVIOR: "Business - Organizational Behavior",
    SPECIAL_EDUCATION_SUBJECT_ADD_ADHD: "Special Education - ADD / ADHD",
    SPECIAL_EDUCATION_SUBJECT_DYSLEXIA: "Special Education - Dyslexia",
    SPECIAL_EDUCATION_SUBJECT_EMOTIONAL_BEHAVIOR: "Special Education - Emotional Behavior",
    SPECIAL_EDUCATION_SUBJECT_HEARING_IMPAIRED: "Special Education - Hearing Impaired",
    SPECIAL_EDUCATION_SUBJECT_LEARNING_DISABLED: "Special Education - Learning Disabled",
    SPECIAL_EDUCATION_SUBJECT_MILDLY_HANDICAPPED: "Special Education - Mildly Handicapped"
};
var convertSubjectsToStrings = function(subjects) {
    if (!subjects) return [];
    var readableStrings = subjects.map(function(subject) {
        return GQL_TUTORING_SUBJECTS_TABLE[subject];
    });
    return readableStrings;
};

;// CONCATENATED MODULE: ./src/components/CaregiverProfile/TutoringServices.tsx










var TutoringServices = function(param) {
    var tutoringProfile = param.tutoringProfile, merchandizedJobInterests = param.merchandizedJobInterests, firstName = param.firstName;
    var ref, ref1;
    var payRange = tutoringProfile.payRange, supportedServices = tutoringProfile.supportedServices, specificSubjects = tutoringProfile.specificSubjects, otherSpecificSubject = tutoringProfile.otherSpecificSubject, _otherGeneralSubjects = tutoringProfile.otherGeneralSubjects, otherGeneralSubjects = _otherGeneralSubjects === void 0 ? [] : _otherGeneralSubjects;
    var convertedSubjects = convertSubjectsToStrings(specificSubjects).sort();
    var renderedSubjects = (0,_to_consumable_array/* default */.Z)(convertedSubjects).concat((0,_to_consumable_array/* default */.Z)(otherGeneralSubjects), [
        otherSpecificSubject
    ]).filter(function(element) {
        return !!element;
    }).sort();
    var renderedCanHelpWith = (0,mapQualitiesAndServices/* default */.Z)((0,_object_spread/* default */.Z)({}, merchandizedJobInterests, supportedServices)).sort();
    var toRate = (payRange === null || payRange === void 0 ? void 0 : (ref = payRange.hourlyRateTo) === null || ref === void 0 ? void 0 : ref.amount) || "0";
    var fromRate = (payRange === null || payRange === void 0 ? void 0 : (ref1 = payRange.hourlyRateFrom) === null || ref1 === void 0 ? void 0 : ref1.amount) || "0";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
        item: true,
        container: true,
        xs: 12,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                item: true,
                xs: 12,
                sm: 7,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        children: renderedSubjects.length === 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(AttributeList/* default */.Z, {
                            label: "Subjects",
                            content: "".concat(firstName, " hasn't provided this information.")
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(AttributeList/* default */.Z, {
                            label: "Subjects",
                            content: renderedSubjects,
                            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon24UtilityCheckmark/* default */.Z, {})
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                        mt: 3,
                        mb: {
                            xs: 3,
                            sm: 0
                        },
                        maxWidth: 326,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                variant: "h4",
                                component: "p",
                                children: "Rates"
                            }),
                            !fromRate && !toRate ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                mt: 1,
                                children: [
                                    firstName,
                                    " hasn't provided this information."
                                ]
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                mt: 1,
                                children: (Number(fromRate) > 0 || Number(toRate) > 0) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                    display: "flex",
                                    justifyContent: "space-between",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                            variant: "body2",
                                            children: "Recurring jobs"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                            variant: "h4",
                                            component: "p",
                                            children: [
                                                (0,payRangeHelper/* default */.Z)(toRate, fromRate),
                                                "/hr"
                                            ]
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CanHelpWith, {
                firstName: firstName,
                canHelpWithList: renderedCanHelpWith
            })
        ]
    });
};


;// CONCATENATED MODULE: ./src/components/CaregiverProfile/HousekeepingServices.tsx







var HousekeepingServices = function(param) {
    var housekeepingProfile = param.housekeepingProfile, merchandizedJobInterests = param.merchandizedJobInterests, firstName = param.firstName;
    var ref, ref1;
    var supportedServices = housekeepingProfile.supportedServices, recurringRate = housekeepingProfile.recurringRate;
    var renderedCanHelpWith = (0,mapQualitiesAndServices/* default */.Z)((0,_object_spread/* default */.Z)({}, merchandizedJobInterests)).sort();
    var toRate = (recurringRate === null || recurringRate === void 0 ? void 0 : (ref = recurringRate.hourlyRateTo) === null || ref === void 0 ? void 0 : ref.amount) || "0";
    var fromRate = (recurringRate === null || recurringRate === void 0 ? void 0 : (ref1 = recurringRate.hourlyRateFrom) === null || ref1 === void 0 ? void 0 : ref1.amount) || "0";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
        item: true,
        container: true,
        xs: 12,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                item: true,
                xs: 12,
                sm: 7,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ServicesOffered, {
                        firstName: firstName,
                        supportedServices: supportedServices
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                        mt: 3,
                        mb: {
                            xs: 3,
                            sm: 0
                        },
                        maxWidth: 326,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                variant: "h4",
                                component: "p",
                                pb: 1,
                                children: "Rates"
                            }),
                            !fromRate && !toRate ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                children: [
                                    firstName,
                                    " hasn't provided this information."
                                ]
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                children: (Number(fromRate) > 0 || Number(toRate) > 0) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                    display: "flex",
                                    justifyContent: "space-between",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                            variant: "body2",
                                            children: "Recurring jobs"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                            variant: "h4",
                                            component: "p",
                                            children: [
                                                (0,payRangeHelper/* default */.Z)(toRate, fromRate),
                                                "/hr"
                                            ]
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CanHelpWith, {
                firstName: firstName,
                canHelpWithList: renderedCanHelpWith
            })
        ]
    });
};


;// CONCATENATED MODULE: ./src/components/CaregiverProfile/Sections/ServicesSection.tsx







var ServicesSection = function(param) {
    var activeProfile = param.activeProfile, merchandizedJobInterests = param.merchandizedJobInterests, firstName = param.firstName;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Section, {
        title: "Services",
        displayDivider: true,
        children: [
            activeProfile.__typename === "ChildCareCaregiverProfile" && /*#__PURE__*/ (0,jsx_runtime.jsx)(ChildCareServices, {
                childCareProfile: activeProfile,
                merchandizedJobInterests: merchandizedJobInterests,
                firstName: firstName
            }),
            activeProfile.__typename === "PetCareCaregiverProfile" && /*#__PURE__*/ (0,jsx_runtime.jsx)(PetCareServices, {
                petCareProfile: activeProfile,
                merchandizedJobInterests: merchandizedJobInterests,
                firstName: firstName
            }),
            activeProfile.__typename === "SeniorCareCaregiverProfile" && /*#__PURE__*/ (0,jsx_runtime.jsx)(SeniorCareServices, {
                seniorCareProfile: activeProfile,
                merchandizedJobInterests: merchandizedJobInterests,
                firstName: firstName
            }),
            activeProfile.__typename === "TutoringCaregiverProfile" && /*#__PURE__*/ (0,jsx_runtime.jsx)(TutoringServices, {
                tutoringProfile: activeProfile,
                merchandizedJobInterests: merchandizedJobInterests,
                firstName: firstName
            }),
            activeProfile.__typename === "HouseKeepingCaregiverProfile" && /*#__PURE__*/ (0,jsx_runtime.jsx)(HousekeepingServices, {
                housekeepingProfile: activeProfile,
                merchandizedJobInterests: merchandizedJobInterests,
                firstName: firstName
            })
        ]
    });
};


// EXTERNAL MODULE: ./src/components/CaregiverProfile/ProfilePageSchema.tsx
var ProfilePageSchema = __webpack_require__(99014);
// EXTERNAL MODULE: ./src/components/hooks/useLDClientFlags.tsx
var useLDClientFlags = __webpack_require__(32778);
// EXTERNAL MODULE: ./src/components/GAMAds.tsx
var GAMAds = __webpack_require__(5823);
// EXTERNAL MODULE: ./src/components/pages/segmentationDetails/caregiver/hooks/useAmplitudeTracking.ts
var useAmplitudeTracking = __webpack_require__(37187);
// EXTERNAL MODULE: ./src/components/pages/segmentationDetails/caregiver/hooks/useMetaTags.ts
var useMetaTags = __webpack_require__(54847);
// EXTERNAL MODULE: ./src/components/pages/segmentationDetails/caregiver/shared/MetaHead.tsx
var MetaHead = __webpack_require__(12800);
;// CONCATENATED MODULE: ./src/components/pages/segmentationDetails/caregiver/UnifiedCaregiverDetail.tsx






























var UnifiedCaregiverDetail = function(param) {
    var data = param.pageData, serviceShortName = param.serviceShortName, testName = param.testName, deviceChar = param.deviceChar, seoSegmentId = param.seoSegmentId;
    var ref, ref1, ref2, ref3, ref4, ref5;
    var ref6 = config_default()(), NEXT_PUBLIC_APP_URL = ref6.publicRuntimeConfig.NEXT_PUBLIC_APP_URL;
    var isMobile = (0,useMediaQuery/* default */.Z)(function(theme) {
        return theme.breakpoints.down("md");
    });
    var isDesktop = (0,useMediaQuery/* default */.Z)(function(theme) {
        return theme.breakpoints.up("md");
    });
    var seoProfileUrl = NEXT_PUBLIC_APP_URL + seoSegmentId;
    var ref7 = (0,useLDClientFlags/* useLDClientFlags */.y)(), GAMFlag = ref7.SEO_3487_GAM_ADS_SEO_MFE;
    var showGAMAd = (GAMFlag === null || GAMFlag === void 0 ? void 0 : GAMFlag.variationIndex) === 1;
    var gamRef = (0,react.useRef)(null);
    var ref8 = (0,react.useState)(false), gamIsVisible = ref8[0], setGamIsVisible = ref8[1];
    var ref9 = (0,react.useState)(false), openModal = ref9[0], setOpenModal = ref9[1];
    var _getCaregiver = data.getCaregiver, hasCareCheck = _getCaregiver.hasCareCheck, member = _getCaregiver.member, profiles = _getCaregiver.profiles, badges = _getCaregiver.badges, neighborhood = _getCaregiver.placeInfo, recurringAvailability = _getCaregiver.recurringAvailability, educationDegrees = _getCaregiver.educationDegrees, getSEOSegmentationBreadcrumbs = data.getSEOSegmentationBreadcrumbs, revieweeMetrics = data.revieweeMetrics, reviewsByReviewee = data.reviewsByReviewee, serviceProfileId = data.serviceProfileId, publicId = data.publicId;
    var breadcrumbs = getSEOSegmentationBreadcrumbs === null || getSEOSegmentationBreadcrumbs === void 0 ? void 0 : getSEOSegmentationBreadcrumbs.breadcrumbs;
    var activeProfile = function(caregiverProfiles) {
        if (caregiverProfiles === null || caregiverProfiles === void 0 ? void 0 : caregiverProfiles.childCareCaregiverProfile) {
            return caregiverProfiles.childCareCaregiverProfile;
        }
        if (caregiverProfiles === null || caregiverProfiles === void 0 ? void 0 : caregiverProfiles.petCareCaregiverProfile) {
            return caregiverProfiles.petCareCaregiverProfile;
        }
        if (caregiverProfiles === null || caregiverProfiles === void 0 ? void 0 : caregiverProfiles.seniorCareCaregiverProfile) {
            return caregiverProfiles.seniorCareCaregiverProfile;
        }
        if (caregiverProfiles === null || caregiverProfiles === void 0 ? void 0 : caregiverProfiles.tutoringCaregiverProfile) {
            return caregiverProfiles.tutoringCaregiverProfile;
        }
        if (caregiverProfiles === null || caregiverProfiles === void 0 ? void 0 : caregiverProfiles.houseKeepingCaregiverProfile) {
            return caregiverProfiles.houseKeepingCaregiverProfile;
        }
        return null;
    }(profiles);
    var merchandizedJobInterests = function(caregiverProfiles) {
        if (caregiverProfiles === null || caregiverProfiles === void 0 ? void 0 : caregiverProfiles.commonCaregiverProfile) {
            return caregiverProfiles.commonCaregiverProfile.merchandizedJobInterests;
        }
        return null;
    }(profiles);
    var availabilityFrequency = activeProfile && activeProfile.__typename !== "PetCareCaregiverProfile" ? activeProfile.availabilityFrequency : null;
    var revieweeMetricsData = (revieweeMetrics === null || revieweeMetrics === void 0 ? void 0 : revieweeMetrics.__typename) === "RevieweeMetricsPayload" && revieweeMetrics.metrics ? revieweeMetrics.metrics : null;
    var ref10;
    var providerMetadata = (0,getProviderMetadata/* default */.Z)({
        displayName: member.displayName,
        firstName: member.firstName,
        address: member.address ? {
            city: member.address.city,
            state: member.address.state
        } : null,
        yearsOfExperience: activeProfile ? activeProfile.yearsOfExperience : null,
        availability: availabilityFrequency,
        // render Care's logo if provider doesn't have profile picture
        image: member.hiResImageURL ? member.hiResImageURL : "".concat(NEXT_PUBLIC_APP_URL, "/img/care-no-tag.jpg"),
        serviceName: constants/* SEO_SERVICE_MAP_SHORT_NAMES */.yA[serviceShortName],
        hourlyRate: activeProfile === null || activeProfile === void 0 ? void 0 : (ref = activeProfile.payRange) === null || ref === void 0 ? void 0 : ref.hourlyRateFrom.amount,
        bio: activeProfile ? activeProfile.bio.experienceSummary : null,
        totalReviews: (ref10 = revieweeMetricsData === null || revieweeMetricsData === void 0 ? void 0 : revieweeMetricsData.totalReviews) !== null && ref10 !== void 0 ? ref10 : 0,
        isPremium: member.isPremium
    });
    var caregiverList = ((ref1 = data.seoSimilarCaregiverProfiles) === null || ref1 === void 0 ? void 0 : ref1.__typename) === "SEOSimilarCaregiverProfilesSuccess" && ((ref2 = data.seoSimilarCaregiverProfiles) === null || ref2 === void 0 ? void 0 : ref2.similarCaregiverProfiles) ? data.seoSimilarCaregiverProfiles.similarCaregiverProfiles.caregiverList : null;
    var reviewsList = (reviewsByReviewee === null || reviewsByReviewee === void 0 ? void 0 : reviewsByReviewee.__typename) === "ReviewsByRevieweePayload" ? reviewsByReviewee.reviews : [];
    var _aiAssistedBio;
    var hasAiBio = (_aiAssistedBio = profiles === null || profiles === void 0 ? void 0 : (ref3 = profiles.childCareCaregiverProfile) === null || ref3 === void 0 ? void 0 : ref3.bio.aiAssistedBio) !== null && _aiAssistedBio !== void 0 ? _aiAssistedBio : false;
    (0,react.useEffect)(function() {
        var observer = new IntersectionObserver(function(param) {
            var _param = (0,_sliced_to_array/* default */.Z)(param, 1), entry = _param[0];
            if (entry.isIntersecting) {
                setGamIsVisible(true);
                observer.disconnect();
            }
        }, {
            // larger threshold for mobile to ensure ad is loaded
            threshold: isMobile ? 0.5 : 0.2
        });
        var currentGamRef = gamRef.current;
        if (currentGamRef) {
            observer.observe(currentGamRef);
        }
        return function() {
            if (currentGamRef) {
                observer.unobserve(currentGamRef);
            }
        };
    }, [
        gamRef,
        isMobile
    ]);
    (0,useAmplitudeTracking/* default */.Z)({
        deviceChar: deviceChar,
        testName: testName,
        hasCareCheck: hasCareCheck,
        serviceShortName: serviceShortName,
        hasAiBio: hasAiBio
    });
    var metaTags = (0,useMetaTags/* default */.Z)(providerMetadata);
    var enrollmentURL = (0,generateEnrollmentUrl/* default */.Z)({
        serviceShortName: serviceShortName,
        isMobile: isMobile,
        serviceProfileId: serviceProfileId
    });
    (0,react.useEffect)(function() {
        if (gamIsVisible && GAMFlag && GAMFlag.reason.kind === constants/* LaunchDarklyEvaluationReasons.RULE_MATCH */.Dn.RULE_MATCH) {
            (0,analyticsHelper/* trackAmplitudeEvent */.rG)(analyticsHelper/* AmplitudeEvent.testExposure */.Sj.testExposure, {
                test_name: constants/* UI_FEATURE_FLAGS.SEO_3487_GAM_ADS_SEO_MFE.id */.WV.SEO_3487_GAM_ADS_SEO_MFE.id,
                test_variant: GAMFlag.variationIndex,
                service_short_name: serviceShortName
            });
        }
    }, [
        GAMFlag,
        gamIsVisible,
        serviceShortName
    ]);
    var ref11, ref12, ref13;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        "data-testid": "unified-profile",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MetaHead/* default */.Z, {
                pageTitle: providerMetadata.title,
                metaTags: metaTags,
                seoProfileUrl: seoProfileUrl
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProfilePageSchema/* ProfilePageSchema */.q, {
                displayName: member.displayName,
                description: providerMetadata.description,
                imageURL: providerMetadata.image
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SeoGlobalNavbar/* default */.Z, {
                enrollmentURL: enrollmentURL
            }),
            breadcrumbs && /*#__PURE__*/ (0,jsx_runtime.jsx)(Sections_BreadcrumbsSection, {
                breadcrumbs: breadcrumbs
            }),
            !member.isPremium && /*#__PURE__*/ (0,jsx_runtime.jsx)(Sections_ZipCodeCTASection, {
                enrollmentURL: enrollmentURL,
                serviceShortName: serviceShortName,
                areBreadcrumbsPresent: !!breadcrumbs
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CaregiverProfile_CaregiverCard, {
                profileImage: member.hiResImageURL,
                displayName: member.displayName,
                badges: badges,
                neighborhood: neighborhood,
                address: member.address,
                baseHourlyRate: activeProfile === null || activeProfile === void 0 ? void 0 : (ref4 = activeProfile.payRange) === null || ref4 === void 0 ? void 0 : ref4.hourlyRateFrom.amount,
                enrollmentURL: enrollmentURL,
                revieweeMetrics: revieweeMetricsData,
                experience: (activeProfile === null || activeProfile === void 0 ? void 0 : activeProfile.yearsOfExperience) || undefined
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                maxWidth: "md",
                disableGutters: isDesktop,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                    container: true,
                    item: true,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                            item: true,
                            md: 8,
                            children: [
                                hasCareCheck && /*#__PURE__*/ (0,jsx_runtime.jsx)(SafetyCardSection, {
                                    firstName: member.firstName,
                                    caregiverStateCode: (ref11 = (ref5 = member.address) === null || ref5 === void 0 ? void 0 : ref5.state) !== null && ref11 !== void 0 ? ref11 : null
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(AboutCaregiverSection, {
                                    firstName: member.firstName,
                                    yearsOfExperience: activeProfile === null || activeProfile === void 0 ? void 0 : activeProfile.yearsOfExperience,
                                    experienceSummary: activeProfile === null || activeProfile === void 0 ? void 0 : activeProfile.bio.experienceSummary,
                                    isVaccinated: data.getCaregiver.isVaccinated,
                                    isAiAssistedBio: hasAiBio
                                }),
                                showGAMAd && isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                    item: true,
                                    ref: gamRef,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(GAMAds/* GAMAds */.U, {
                                        slotName: constants/* HTL_SLOTS.SEO_PROV_PROFILE_INLINE_1 */.YQ.SEO_PROV_PROFILE_INLINE_1
                                    })
                                }),
                                (revieweeMetricsData || publicId) && /*#__PURE__*/ (0,jsx_runtime.jsx)(MostRecentReviewSection, {
                                    reviews: reviewsList,
                                    averageRatings: (ref12 = revieweeMetricsData === null || revieweeMetricsData === void 0 ? void 0 : revieweeMetricsData.averageRatings) !== null && ref12 !== void 0 ? ref12 : [],
                                    totalReviews: (ref13 = revieweeMetricsData === null || revieweeMetricsData === void 0 ? void 0 : revieweeMetricsData.totalReviews) !== null && ref13 !== void 0 ? ref13 : 0,
                                    setOpenModal: setOpenModal,
                                    openModal: openModal,
                                    publicId: publicId,
                                    serviceShortName: constants/* SERVICE_SHORT_NAMES */.Ab[serviceShortName],
                                    firstName: member.firstName
                                }),
                                activeProfile && merchandizedJobInterests && /*#__PURE__*/ (0,jsx_runtime.jsx)(ServicesSection, {
                                    activeProfile: activeProfile,
                                    merchandizedJobInterests: merchandizedJobInterests,
                                    firstName: member.firstName
                                }),
                                activeProfile && /*#__PURE__*/ (0,jsx_runtime.jsx)(QualitiesSection, {
                                    activeProfile: activeProfile,
                                    educationDegrees: educationDegrees,
                                    firstName: member.firstName,
                                    languages: member.languages
                                }),
                                recurringAvailability && /*#__PURE__*/ (0,jsx_runtime.jsx)(Sections_AvailabilitySection, {
                                    firstName: member.firstName,
                                    recurringAvailability: recurringAvailability
                                }),
                                showGAMAd && /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                    item: true,
                                    ml: {
                                        lg: 12
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(GAMAds/* GAMAds */.U, {
                                        slotName: isDesktop ? constants/* HTL_SLOTS.SEO_PROV_PROFILE_INLINE_1 */.YQ.SEO_PROV_PROFILE_INLINE_1 : constants/* HTL_SLOTS.SEO_PROV_PROFILE_INLINE_2 */.YQ.SEO_PROV_PROFILE_INLINE_2
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Sections_SafetySection, {
                                    hasCareCheck: hasCareCheck
                                }),
                                caregiverList && /*#__PURE__*/ (0,jsx_runtime.jsx)(SimilarCaregiverSection, {
                                    profiles: caregiverList
                                }),
                                isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)(JoinToContactSection, {
                                    ctaText: "Join to contact",
                                    enrollmentURL: enrollmentURL
                                })
                            ]
                        }),
                        showGAMAd && isDesktop && /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                            item: true,
                            md: 4,
                            pl: 4,
                            ref: gamRef,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(GAMAds/* GAMAds */.U, {
                                slotName: constants/* HTL_SLOTS.SEO_PROV_PROFILE_RR_1 */.YQ.SEO_PROV_PROFILE_RR_1
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                mt: 4,
                pb: 8,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CoreGlobalFooter/* default */.Z, {})
            }),
            revieweeMetricsData && (reviewsByReviewee === null || reviewsByReviewee === void 0 ? void 0 : reviewsByReviewee.__typename) === "ReviewsByRevieweePayload" && /*#__PURE__*/ (0,jsx_runtime.jsx)(ReviewsModal, {
                openModal: openModal,
                setOpenModal: setOpenModal,
                reviews: reviewsByReviewee.reviews,
                averageRatings: revieweeMetricsData.averageRatings,
                totalReviews: revieweeMetricsData.totalReviews
            })
        ]
    });
};
/* harmony default export */ var caregiver_UnifiedCaregiverDetail = (UnifiedCaregiverDetail);


/***/ }),

/***/ 7360:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ getZipcodeFromGeoInfo; }
/* harmony export */ });
var getZipcodeFromGeoInfo = function(userGeoInfo) {
    var match = userGeoInfo === null || userGeoInfo === void 0 ? void 0 : userGeoInfo.match(/zip=(\d{5})/);
    if (match && match[1]) {
        return match[1];
    }
    return "";
};


/***/ })

}]);